<template>
  <md-dialog
      :class="{
        'md-dialog-registration': true,
        'md-confirming': showConfirmOverride || showConfirmDuplicate || showConfirmGetRegistry || downloading || showCompleteModal
          || (loadBuildingNumbers && registrationItem === null)
      }"
      :md-active.sync="showRegistrationDialog"
      :md-click-outside-to-close="false"
      :md-close-on-esc="false">
    <md-dialog-title class="md-title">{{
        (loadRegistrations || !form.address) ? '' : [
          '所在 : ', form.address.pref, form.address.city, form.address.large_section, form.address.small_section].join('')
      }}
    </md-dialog-title>
    <div class="md-dialog-close-button" @click="close">
      <md-icon>close</md-icon>
    </div>
    <md-dialog-content>
      <!-- 1. 取得する地番/家屋番号を選択してください-->
      <div class="md-title">取得する情報を選択の上、「取得」ボタンをクリックしてください。</div>
      <div class="md-layout mb-0">
        <div class="md-layout-item">
          <!--土地-->
          <md-table class="parcel-number">
            <md-table-row>
              <md-table-head :class="{'md-hidden': multiPointMode === false}"></md-table-head>
              <md-table-head>土地 / 建物</md-table-head>
              <md-table-head>全部事項</md-table-head>
              <md-table-head>
                <md-button class="md-icon-button" :class="{'md-primary': selectAllWholeData()}" :disabled="isSending()"
                           @click="toggleWholeData">
                  <md-icon>done_all</md-icon>
                </md-button>
              </md-table-head>
              <md-table-head>所有者事項</md-table-head>
              <md-table-head>
                <md-button class="md-icon-button" :class="{'md-primary': selectAllOwnerData()}" :disabled="isSending()"
                           @click="toggleOwnerData">
                  <md-icon>done_all</md-icon>
                </md-button>
              </md-table-head>
              <md-table-head>地図(公図)</md-table-head>
              <md-table-head>
                <md-button class="md-icon-button" :class="{'md-primary': selectAllMap()}" :disabled="isSending()"
                           @click="toggleMap">
                  <md-icon>done_all</md-icon>
                </md-button>
              </md-table-head>
              <md-table-head colspan="2">地積測量図 / 建物図面</md-table-head>
              <md-table-head>
                <md-button class="md-icon-button" :class="{'md-primary': selectAllLandSurveyMap()}"
                           :disabled="isSending()" @click="toggleLandSurveyMap">
                  <md-icon>done_all</md-icon>
                </md-button>
              </md-table-head>
              <md-table-head colspan="2">地役権図面</md-table-head>
              <md-table-head>
                <md-button class="md-icon-button" :class="{'md-primary': selectAllEasementDrawing()}"
                           :disabled="isSending()" @click="toggleEasementDrawing">
                  <md-icon>done_all</md-icon>
                </md-button>
              </md-table-head>
            </md-table-row>
            <md-table-row :key="'lot-number-' + index" v-for="(item, index) in lotNumber" slot="md-table-row"
                          :v-if="registrationItem === null">
              <md-table-cell :class="{'md-hidden': multiPointMode === false}"><img
                  :src="`https://cdn.jon-api.com/shikaku-map/img/marker-${index + 1}.png`"/></md-table-cell>
              <md-table-cell>土）{{ item.large_section + item.small_section + item.parcel_number }}</md-table-cell>
              <!--土地.全部事項-->
              <md-table-cell md-label="土地.全部事項">
                <!-- ローディング表示 -->
                <div class="md-layout md-alignment-center-center"
                     v-if="item.status[Common.pdfTypeWholeData]['status'] === 0">
                  <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                </div>
                <!-- PDF取得時 -->
                <div class="md-layout md-alignment-center-center"
                     v-else-if="item.status[Common.pdfTypeWholeData]['pre_signed_url']">
                  <a :href="''" @click.prevent="downloadPdf(item.status[Common.pdfTypeWholeData])"
                     v-html="requestedAtFormat(item.status[Common.pdfTypeWholeData]['requested_at'])"></a>
                </div>
                <!-- PDF取得失敗時 -->
                <div class="md-layout md-alignment-center-center" v-else>
                  <a
                      href="#"
                      @click="showPdfError(item.status[Common.pdfTypeWholeData]['summary'], item.status[Common.pdfTypeWholeData]['message'])"
                  >{{ item.status[Common.pdfTypeWholeData]['summary'] }}</a>
                </div>
              </md-table-cell>
              <md-table-cell md-label="土地.全部事項チェックボックス">
                <md-checkbox :value="item.parcel_number" v-model="form.checkParcelWholeData"
                             @change="checkboxChanged(Common.pdfTypeWholeData)"
                             :disabled="isSending()"></md-checkbox>
              </md-table-cell>
              <!--土地.所有者事項-->
              <md-table-cell md-label="土地.所有者事項">
                <div class="md-layout md-alignment-center-center">
                  <!-- ローディング表示 -->
                  <div class="md-layout md-alignment-center-center"
                       v-if="item.status[Common.pdfTypeOwnerData]['status'] === 0">
                    <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                  </div>
                  <!-- PDF取得時 -->
                  <div class="md-layout md-alignment-center-center"
                       v-else-if="item.status[Common.pdfTypeOwnerData]['pre_signed_url']">
                    <a :href="''" @click.prevent="downloadPdf(item.status[Common.pdfTypeOwnerData])"
                       v-html="requestedAtFormat(item.status[Common.pdfTypeOwnerData]['requested_at'])"></a>
                  </div>
                  <!-- PDF取得失敗時 -->
                  <div class="md-layout md-alignment-center-center" v-else>
                    <a
                        href="#"
                        @click="showPdfError(item.status[Common.pdfTypeOwnerData]['summary'], item.status[Common.pdfTypeOwnerData]['message'])"
                    >{{ item.status[Common.pdfTypeOwnerData]['summary'] }}</a>
                  </div>
                </div>
              </md-table-cell>
              <md-table-cell md-label="土地.所有者事項チェックボックス">
                <md-checkbox :value="item.parcel_number" v-model="form.checkParcelOwnerData"
                             @change="checkboxChanged(Common.pdfTypeOwnerData)"
                             :disabled="isSending()"></md-checkbox>
              </md-table-cell>
              <!--土地.地図(公図)-->
              <md-table-cell md-label="土地.地図(公図)">
                <div class="md-layout md-alignment-center-center">
                  <!-- ローディング表示 -->
                  <div class="md-layout md-alignment-center-center"
                       v-if="item.status[Common.pdfTypeMap]['status'] === 0">
                    <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                  </div>
                  <!-- PDF取得時 -->
                  <div class="md-layout md-alignment-center-center"
                       v-else-if="item.status[Common.pdfTypeMap]['pre_signed_url']">
                    <a :href="''" @click.prevent="downloadPdf(item.status[Common.pdfTypeMap])"
                       v-html="requestedAtFormat(item.status[Common.pdfTypeMap]['requested_at'])"></a>
                  </div>
                  <!-- PDF取得失敗時 -->
                  <div class="md-layout md-alignment-center-center" v-else>
                    <a
                        href="#"
                        @click="showPdfError(item.status[Common.pdfTypeMap]['summary'], item.status[Common.pdfTypeMap]['message'])"
                    >{{ item.status[Common.pdfTypeMap]['summary'] }}</a>
                  </div>
                </div>
              </md-table-cell>
              <md-table-cell md-label="土地.地図(公図)チェックボックス">
                <md-checkbox :value="item.parcel_number" v-model="form.checkParcelMap"
                             @change="checkboxChanged(Common.pdfTypeMap)"
                             :disabled="isSending()"></md-checkbox>
              </md-table-cell>
              <!--土地.地積測量図-->
              <md-table-cell md-label="土地.地積測量図">
                <div class="md-layout md-alignment-center-center">
                  <!-- ローディング表示 -->
                  <div class="md-layout md-alignment-center-center"
                       v-if="item.status[Common.pdfTypeLandSurveyMap]['status'] === 0">
                    <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                  </div>
                  <!-- 取得不可時 -->
                  <div class="md-layout md-alignment-center-center"
                       v-else-if="! tServiceAvailableMapAndDrawings && errorMessages.length > 0">
                    <a :href="''" @click.prevent="showError(`【取得不可】${Common.messages.registration.not_available}`)">取得不可</a>
                  </div>
                  <!-- PDF取得時 -->
                  <div class="md-layout md-alignment-center-center"
                       v-else-if="item.status[Common.pdfTypeLandSurveyMap]['pre_signed_url']">
                    <a :href="''" @click.prevent="downloadPdf(item.status[Common.pdfTypeLandSurveyMap])"
                       v-html="requestedAtFormat(item.status[Common.pdfTypeLandSurveyMap]['requested_at'])"></a>
                  </div>
                  <!-- PDF取得失敗時 -->
                  <div class="md-layout md-alignment-center-center" v-else>
                    <a
                        href="#"
                        @click="showPdfError(item.status[Common.pdfTypeLandSurveyMap]['summary'], item.status[Common.pdfTypeLandSurveyMap]['message'])"
                    >{{ item.status[Common.pdfTypeLandSurveyMap]['summary'] }}</a>
                  </div>
                </div>
              </md-table-cell>
              <md-table-cell md-label="土地.地積測量図事件情報">
                <div class="md-layout md-alignment-center-center"
                     v-if="item.status[Common.pdfTypeLandSurveyMap].incidents.loading === true">
                  <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                </div>
                <md-field class="md-layout md-layout-item md-alignment-top-center"
                          v-else-if="item.status[Common.pdfTypeLandSurveyMap].incidents.list && item.status[Common.pdfTypeLandSurveyMap].incidents.list.length > 0">
                  <md-select :name="item.parcel_number + '-map-incidents'" ref="mdSelect" @md-selected="mdSelected"
                             :disabled="isSending()" v-model="form.incidentLandSelected[item.parcel_number]">
                    <md-option v-for="(incident, index) in item.status[Common.pdfTypeLandSurveyMap].incidents.list"
                               v-bind:key="item.parcel_number + '-map-incidents-' + Common.pdfTypeLandSurveyMap + index"
                               :value="incident.id">
                      {{ incident.registered_date }}
                    </md-option>
                  </md-select>
                </md-field>
                <div class="md-layout md-alignment-center-center" v-else>
                  <label>{{
                      (item.status[Common.pdfTypeLandSurveyMap].incidents.list &&
                          item.status[Common.pdfTypeLandSurveyMap].incidents.list.length === 0) && tServiceAvailableMapAndDrawings ? '該当ありません' : ''
                    }}</label>
                </div>
              </md-table-cell>
              <md-table-cell md-label="土地.地積測量図チェックボックス">
                <md-checkbox v-model="form.checkParcelLandSurveyMap" :value="item.parcel_number"
                             @change="checkboxChanged(Common.pdfTypeLandSurveyMap)"
                             :disabled="isSending()"></md-checkbox>
              </md-table-cell>
              <!--土地.地役権図面-->
              <md-table-cell md-label="土地.地役権図面">
                <div class="md-layout md-alignment-center-center">
                  <!-- ローディング表示 -->
                  <div class="md-layout md-alignment-center-center"
                       v-if="item.status[Common.pdfTypeEasementDrawing]['status'] === 0">
                    <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                  </div>
                  <!-- 取得不可時 -->
                  <div class="md-layout md-alignment-center-center"
                       v-else-if="! tServiceAvailableMapAndDrawings && errorMessages.length > 0">
                    <a :href="''" @click.prevent="showError(`【取得不可】${Common.messages.registration.not_available}`)">取得不可</a>
                  </div>
                  <!-- PDF取得時 -->
                  <div class="md-layout md-alignment-center-center"
                       v-else-if="item.status[Common.pdfTypeEasementDrawing]['pre_signed_url']">
                    <a :href="''" @click.prevent="downloadPdf(item.status[Common.pdfTypeEasementDrawing])"
                       v-html="requestedAtFormat(item.status[Common.pdfTypeEasementDrawing]['requested_at'])"></a>
                  </div>
                  <!-- PDF取得失敗時 -->
                  <div class="md-layout md-alignment-center-center" v-else>
                    <a
                        href="#"
                        @click="showPdfError(item.status[Common.pdfTypeEasementDrawing]['summary'], item.status[Common.pdfTypeEasementDrawing]['message'])"
                    >{{ item.status[Common.pdfTypeEasementDrawing]['summary'] }}</a>
                  </div>
                </div>
              </md-table-cell>
              <md-table-cell md-label="土地.地役権図面事件情報">
                <!-- ローディング表示 -->
                <div class="md-layout md-alignment-center-center"
                     v-if="item.status[Common.pdfTypeEasementDrawing].incidents.loading === true">
                  <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                </div>
                <md-field class="md-layout md-layout-item md-alignment-top-center"
                          v-else-if="item.status[Common.pdfTypeEasementDrawing].incidents.list && item.status[Common.pdfTypeEasementDrawing].incidents.list.length > 0">
                  <md-select :name="item.parcel_number + '-easement-incidents'" ref="mdSelect" @md-selected="mdSelected"
                             :id="item.parcel_number + '-easement-incidents'"
                             :disabled="isSending()" v-model="form.incidentEasementSelected[item.parcel_number]">
                    <md-option v-for="(incident, index) in item.status[Common.pdfTypeEasementDrawing].incidents.list"
                               v-bind:key="item.parcel_number + '-easement-incidents-' + Common.pdfTypeEasementDrawing + index"
                               :value="incident.id">
                      {{ incident.registered_date }}
                    </md-option>
                  </md-select>
                </md-field>
                <div class="md-layout md-alignment-center-center" v-else>
                  <label>{{
                      (item.status[Common.pdfTypeEasementDrawing].incidents.list &&
                          item.status[Common.pdfTypeEasementDrawing].incidents.list.length === 0) && tServiceAvailableMapAndDrawings ? '該当ありません' : ''
                    }}</label>
                </div>
              </md-table-cell>
              <md-table-cell md-label="土地.地役権図面チェックボックス">
                <md-checkbox v-model="form.checkParcelEasementDrawing" :value="item.parcel_number"
                             @change="checkboxChanged(Common.pdfTypeEasementDrawing)"
                             :disabled="isSending()"></md-checkbox>
              </md-table-cell>
            </md-table-row>
            <md-table-row :key="'house-lot-number-' + index" slot="md-table-row" v-for="(item, index) in houseNumber"
                          v-show="registrationItem != null">
              <md-table-cell :class="{'md-hidden': multiPointMode === false}"></md-table-cell>
              <md-table-cell>建）{{ item.large_section + item.small_section + item.number }}</md-table-cell>
              <!--建物.全部事項-->
              <md-table-cell md-label="建物.全部事項">
                <!-- ローディング表示 -->
                <div class="md-layout md-alignment-center-center"
                     v-if="item.status[Common.pdfTypeWholeData]['status'] === 0">
                  <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                </div>
                <!-- PDF取得時 -->
                <div class="md-layout md-alignment-center-center"
                     v-else-if="item.status[Common.pdfTypeWholeData]['pre_signed_url']">
                  <a :href="''" @click.prevent="downloadPdf(item.status[Common.pdfTypeWholeData])"
                     v-html="requestedAtFormat(item.status[Common.pdfTypeWholeData]['requested_at'])"></a>
                </div>
                <!-- PDF取得失敗時 -->
                <div class="md-layout md-alignment-center-center" v-else>
                  <a
                      href="#"
                      @click="showPdfError(item.status[Common.pdfTypeWholeData]['summary'], item.status[Common.pdfTypeWholeData]['message'])"
                  >{{ item.status[Common.pdfTypeWholeData]['summary'] }}</a>
                </div>
              </md-table-cell>
              <md-table-cell md-label="建物.全部事項チェックボックス">
                <md-checkbox :value="item.number" v-model="form.checkBuildingWholeData"
                             @change="checkboxChanged(Common.pdfTypeWholeData)"
                             :disabled="isSending()"></md-checkbox>
              </md-table-cell>
              <!--建物.所有者事項-->
              <md-table-cell md-label="建物.所有者事項">
                <!-- ローディング表示 -->
                <div class="md-layout md-alignment-center-center"
                     v-if="item.status[Common.pdfTypeOwnerData]['status'] === 0">
                  <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                </div>
                <!-- PDF取得時 -->
                <div class="md-layout md-alignment-center-center"
                     v-else-if="item.status[Common.pdfTypeOwnerData]['pre_signed_url']">
                  <a :href="''" @click.prevent="downloadPdf(item.status[Common.pdfTypeOwnerData])"
                     v-html="requestedAtFormat(item.status[Common.pdfTypeOwnerData]['requested_at'])"></a>
                </div>
                <!-- PDF取得失敗時 -->
                <div class="md-layout md-alignment-center-center" v-else>
                  <a
                      href="#"
                      @click="showPdfError(item.status[Common.pdfTypeOwnerData]['summary'], item.status[Common.pdfTypeOwnerData]['message'])"
                  >{{ item.status[Common.pdfTypeOwnerData]['summary'] }}</a>
                </div>
              </md-table-cell>
              <md-table-cell md-label="建物.所有者事項チェックボックス">
                <md-checkbox :value="item.number" v-model="form.checkBuildingOwnerData"
                             @change="checkboxChanged(Common.pdfTypeOwnerData)"
                             :disabled="isSending()"></md-checkbox>
              </md-table-cell>
              <!--建物.余白-->
              <md-table-cell></md-table-cell>
              <md-table-cell></md-table-cell>
              <!--建物.建物図面-->
              <md-table-cell md-label="建物.建物図面">
                <!-- ローディング表示 -->
                <div class="md-layout md-alignment-center-center"
                     v-if="item.status[Common.pdfTypeBuildingDrawing]['status'] === 0">
                  <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                </div>
                <!-- PDF取得時 -->
                <div class="md-layout md-alignment-center-center"
                     v-else-if="item.status[Common.pdfTypeBuildingDrawing]['pre_signed_url']">
                  <a :href="''" @click.prevent="downloadPdf(item.status[Common.pdfTypeBuildingDrawing])"
                     v-html="requestedAtFormat(item.status[Common.pdfTypeBuildingDrawing]['requested_at'])"></a>
                </div>
                <!-- PDF取得失敗時 -->
                <div class="md-layout md-alignment-center-center" v-else>
                  <a
                      href="#"
                      @click="showPdfError(item.status[Common.pdfTypeBuildingDrawing]['summary'], item.status[Common.pdfTypeBuildingDrawing]['message'])"
                  >{{ item.status[Common.pdfTypeBuildingDrawing]['summary'] }}</a>
                </div>
              </md-table-cell>
              <md-table-cell md-label="建物.建物図面事件情報">
                <!-- ローディング表示 -->
                <div class="md-layout md-alignment-center-center"
                     v-if="item.status[Common.pdfTypeBuildingDrawing].incidents.loading === true">
                  <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                </div>
                <md-field class="md-layout md-layout-item md-alignment-top-center"
                          v-else-if="item.status[Common.pdfTypeBuildingDrawing].incidents.list && item.status[Common.pdfTypeBuildingDrawing].incidents.list.length > 0">
                  <md-select v-model="form.incidentDrawingSelected[item.number]"
                             :name="item.number + '-building-incidents'"
                             :disabled="isSending()" ref="mdSelect" @md-selected="mdSelected">
                    <md-option v-for="(incident, index) in item.status[Common.pdfTypeBuildingDrawing].incidents.list"
                               v-bind:key="item.number + '-building-incidents-' + Common.pdfTypeBuildingDrawing + index"
                               :value="incident.id">
                      {{ incident.registered_date }}
                    </md-option>
                  </md-select>
                </md-field>
                <div class="md-layout md-alignment-center-center" v-else>
                  <label>{{
                      (item.status[Common.pdfTypeBuildingDrawing].incidents.list &&
                          item.status[Common.pdfTypeBuildingDrawing].incidents.list.length === 0) && tServiceAvailableMapAndDrawings ? '該当ありません' : ''
                    }}</label>
                </div>
              </md-table-cell>
              <md-table-cell md-label="建物.建物図面チェックボックス">
                <md-checkbox :value="item.number" v-model="form.checkBuildingDrawings"
                             @change="checkboxChanged(Common.pdfTypeBuildingDrawing)"
                             :disabled="isSending()"></md-checkbox>
              </md-table-cell>
              <!--建物.余白-->
              <md-table-cell></md-table-cell>
              <md-table-cell></md-table-cell>
              <md-table-cell></md-table-cell>
            </md-table-row>
          </md-table>
          <!--建物-->
          <md-table class="house-number" v-bind:style="houseNumberHeight()" v-show="registrationItem == null">
            <md-table-row :key="'house-number-' + index" slot="md-table-row" v-for="(item, index) in houseNumber">
              <md-table-cell :class="{'md-hidden': multiPointMode === false}"></md-table-cell>
              <md-table-cell>建）{{ item.large_section + item.small_section + item.number }}</md-table-cell>
              <!--建物.全部事項-->
              <md-table-cell md-label="建物.全部事項">
                <!-- ローディング表示 -->
                <div class="md-layout md-alignment-center-center"
                     v-if="item.status[Common.pdfTypeWholeData]['status'] === 0">
                  <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                </div>
                <!-- PDF取得時 -->
                <div class="md-layout md-alignment-center-center"
                     v-else-if="item.status[Common.pdfTypeWholeData]['pre_signed_url']">
                  <a :href="''" @click.prevent="downloadPdf(item.status[Common.pdfTypeWholeData])"
                     v-html="requestedAtFormat(item.status[Common.pdfTypeWholeData]['requested_at'])"></a>
                </div>
                <!-- PDF取得失敗時 -->
                <div class="md-layout md-alignment-center-center" v-else>
                  <a
                      href="#"
                      @click="showPdfError(item.status[Common.pdfTypeWholeData]['summary'], item.status[Common.pdfTypeWholeData]['message'])"
                  >{{ item.status[Common.pdfTypeWholeData]['summary'] }}</a>
                </div>
              </md-table-cell>
              <md-table-cell md-label="建物.全部事項チェックボックス">
                <md-checkbox :value="item.number" v-model="form.checkBuildingWholeData"
                             @change="checkboxChanged(Common.pdfTypeWholeData)"
                             :disabled="isSending()"></md-checkbox>
              </md-table-cell>
              <!--建物.所有者事項-->
              <md-table-cell md-label="建物.所有者事項">
                <!-- ローディング表示 -->
                <div class="md-layout md-alignment-center-center"
                     v-if="item.status[Common.pdfTypeOwnerData]['status'] === 0">
                  <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                </div>
                <!-- PDF取得時 -->
                <div class="md-layout md-alignment-center-center"
                     v-else-if="item.status[Common.pdfTypeOwnerData]['pre_signed_url']">
                  <a :href="''" @click.prevent="downloadPdf(item.status[Common.pdfTypeOwnerData])"
                     v-html="requestedAtFormat(item.status[Common.pdfTypeOwnerData]['requested_at'])"></a>
                </div>
                <!-- PDF取得失敗時 -->
                <div class="md-layout md-alignment-center-center" v-else>
                  <a
                      href="#"
                      @click="showPdfError(item.status[Common.pdfTypeOwnerData]['summary'], item.status[Common.pdfTypeOwnerData]['message'])"
                  >{{ item.status[Common.pdfTypeOwnerData]['summary'] }}</a>
                </div>
              </md-table-cell>
              <md-table-cell md-label="建物.所有者事項チェックボックス">
                <md-checkbox :value="item.number" v-model="form.checkBuildingOwnerData"
                             @change="checkboxChanged(Common.pdfTypeOwnerData)"
                             :disabled="isSending()"></md-checkbox>
              </md-table-cell>
              <!--建物.余白-->
              <md-table-cell></md-table-cell>
              <md-table-cell></md-table-cell>
              <!--建物.建物図面-->
              <md-table-cell md-label="建物.建物図面">
                <!-- ローディング表示 -->
                <div class="md-layout md-alignment-center-center"
                     v-if="item.status[Common.pdfTypeBuildingDrawing]['status'] === 0">
                  <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                </div>
                <!-- 取得不可時 -->
                <div class="md-layout md-alignment-center-center"
                     v-else-if="! tServiceAvailableMapAndDrawings && errorMessages.length > 0">
                  <a :href="''" @click.prevent="showError(`【取得不可】${Common.messages.registration.not_available}`)">取得不可</a>
                </div>
                <!-- PDF取得時 -->
                <div class="md-layout md-alignment-center-center"
                     v-else-if="item.status[Common.pdfTypeBuildingDrawing]['pre_signed_url']">
                  <a :href="''" @click.prevent="downloadPdf(item.status[Common.pdfTypeBuildingDrawing])"
                     v-html="requestedAtFormat(item.status[Common.pdfTypeBuildingDrawing]['requested_at'])"></a>
                </div>
                <!-- PDF取得失敗時 -->
                <div class="md-layout md-alignment-center-center" v-else>
                  <a
                      href="#"
                      @click="showPdfError(item.status[Common.pdfTypeBuildingDrawing]['summary'], item.status[Common.pdfTypeBuildingDrawing]['message'])"
                  >{{ item.status[Common.pdfTypeBuildingDrawing]['summary'] }}</a>
                </div>
              </md-table-cell>
              <md-table-cell md-label="建物.建物図面事件情報">
                <!-- ローディング表示 -->
                <div class="md-layout md-alignment-center-center"
                     v-if="item.status[Common.pdfTypeBuildingDrawing].incidents.loading === true">
                  <md-progress-spinner :md-diameter="15" :md-stroke="2" md-mode="indeterminate"></md-progress-spinner>
                </div>
                <md-field class="md-layout md-layout-item md-alignment-top-center"
                          v-else-if="item.status[Common.pdfTypeBuildingDrawing].incidents.list && item.status[Common.pdfTypeBuildingDrawing].incidents.list.length > 0">
                  <md-select v-model="form.incidentDrawingSelected[item.number]"
                             :name="item.number + '-building-incidents'"
                             :disabled="isSending()" ref="mdSelect" @md-selected="mdSelected">
                    <md-option v-for="(incident, index) in item.status[Common.pdfTypeBuildingDrawing].incidents.list"
                               v-bind:key="item.number + '-building-incidents-' + Common.pdfTypeBuildingDrawing + index"
                               :value="incident.id">
                      {{ incident.registered_date }}
                    </md-option>
                  </md-select>
                </md-field>
                <div class="md-layout md-alignment-center-center" v-else>
                  <label>{{
                      (item.status[Common.pdfTypeBuildingDrawing].incidents.list &&
                          item.status[Common.pdfTypeBuildingDrawing].incidents.list.length === 0) && tServiceAvailableMapAndDrawings ? '該当ありません' : ''
                    }}</label>
                </div>
              </md-table-cell>
              <md-table-cell md-label="建物.建物図面チェックボックス">
                <md-checkbox :value="item.number" v-model="form.checkBuildingDrawings"
                             @change="checkboxChanged(Common.pdfTypeBuildingDrawing)"
                             :disabled="isSending()"></md-checkbox>
              </md-table-cell>
              <!--建物.余白-->
              <md-table-cell></md-table-cell>
              <md-table-cell></md-table-cell>
              <md-table-cell></md-table-cell>
            </md-table-row>
          </md-table>
        </div>
      </div>
      <div :class="getValidationClass('pdfTypeSelected')" class="md-layout pdf-selected-error"
           v-if="form.validating && getValidationClass('pdfTypeSelected')['md-invalid']">
        <div class="md-layout-item md-size-100 md-field md-theme-default md-invalid md-field-remove-input">
          <span class="md-error" v-if="getValidationResponseMessage('pdfTypeSelected')">{{
              getValidationResponseMessage('pdfTypeSelected')
            }}</span>
          <span class="md-error" v-else-if="$v.form.pdfTypeSelected.required === false">{{
              errors.pdfTypeSelected.required
            }}</span>
        </div>
      </div>
      <div :class="{'md-invalid': true}" class="md-layout pdf-selected-error"
           v-else-if="form.validating && form.incidentSelectedError">
        <div class="md-layout-item md-size-100 md-field md-theme-default md-invalid md-field-remove-input">
          <span class="md-error">{{
              errors.incidentSelected.required
            }}</span>
        </div>
      </div>
      <!--操作-->
      <div class="md-layout mb-20">
        <div class="md-layout-item md-size-30">
          <md-button class="md-layout-item md-primary md-raised"
                     v-show="registrationItem === null && multiPointMode === false"
                     @click="fetchBuildingNumbers"
                     :disabled="isSending() || loadedBuildingNumbers || tServiceAvailable === false">
            <md-icon>apartment</md-icon>
            <span>家屋番号を表示</span>
          </md-button>
        </div>
        <div class="md-layout-item"></div>
        <div class="md-layout-item md-size-30">
          <md-button class="md-layout-item md-primary md-raised"
                     @click="fetchIncidents"
                     :disabled="disabledIncidentButton() || tServiceAvailable === false">
            <md-icon>history</md-icon>
            <span>事件情報を表示</span>
          </md-button>
        </div>
      </div>

      <!-- 2. 登記情報提供サービスのパスワードを入力してください-->
      <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-60">
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-30">
              <md-field :class="getValidationClass('t_service_id')">
                <label>登記情報提供ｻｰﾋﾞｽ ID</label>
                <md-input v-if="isTrialUser" v-model="form.t_service_id"></md-input>
                <md-input v-else readonly v-model="tServiceId" disabled></md-input>
                <span class="md-error"
                      v-if="getValidationResponseMessage('t_service_id')">{{
                    getValidationResponseMessage('t_service_id')
                  }}</span>
                <span class="md-error"
                      v-else-if="!$v.form.t_service_id.required">{{ errors.tServiceId.required }}</span>
              </md-field>
            </div>
            <div class="md-layout-item md-field-height-auto md-size-40">
              <md-field :class="getValidationClass('password')">
                <label>登記情報提供ｻｰﾋﾞｽ ﾊﾟｽﾜｰﾄﾞ</label>
                <md-input type="text" v-model="form.password" autocomplete="off"
                          v-show="!isHiddenPassword"
                          ref="password"
                          :disabled="sendingRegistryInfo || tServiceAvailable === false"></md-input>
                <md-input type="text" v-show="isHiddenPassword" v-model="form.hiddenPassword"
                          @focus="triggerPasswordFocus()"></md-input>
                <md-button class="md-icon-button md-icon-sm" v-if="isHiddenPassword" @click="isHiddenPassword = false">
                  <md-icon>visibility_off</md-icon>
                </md-button>
                <md-button class="md-icon-button md-icon-sm" v-else @click="isHiddenPassword = true">
                  <md-icon>visibility</md-icon>
                </md-button>
                <span class="md-error"
                      v-if="getValidationResponseMessage('password')">{{
                    getValidationResponseMessage('password')
                  }}</span>
                <span class="md-error"
                      v-else-if="!$v.form.password.required">{{ errors.password.required }}</span>
              </md-field>
            </div>
            <md-button :disabled="isSending() || tServiceAvailable === false" @click="validateRegistryForm"
                       class="md-layout-item md-size-25 md-primary md-raised">
              <md-icon>cloud_download</md-icon>
              <span>取得</span>
            </md-button>
            <div class="md-layout-item md-size-70">&nbsp;</div>
            <md-button type="button" class="md-primary md-raised md-layout-item md-size-25"
                       @click="onBatchDownload()"
                       :disabled="isSending() || tServiceAvailable === false || unFinishCount > 0"
                       v-show="unFinishCount === 0 && downloadableCount > 0">
              <md-icon>file_download</md-icon>
              一括ダウンロード
            </md-button>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item md-size-70">
              <span v-if="tServiceAvailable === false" class="md-caption text-error">
                ※ 利用時間外のため、登記情報の取得が行えません。
              </span>
              <br v-if="tServiceAvailable === false"/>
              <span class="md-caption">
                ※ 取得した登記情報の料金請求は登記情報提供サービスから行われます。<br/>
                ※ 登記情報請求の利用時間は下記となります。<br/>
                　 全部事項・所有者事項（平日8:30〜22:30・土日祝日8:30〜17:30）<br/>
                　 地図(公図)・地積測量図/建物図面・地役権図面（平日8:30〜20:30）<br/>
                {{
                  isTrialUser ? "※ お持ちの登記情報提供サービスIDとPASSをご入力いただきますと、実際の登記情報を取得することが可能です。（登記情報提供サービスIDをお持ちでない場合はサンプルの閲覧となります）" : ''
                }}<br/>
              </span>
            </div>
            <div class="md-layout-item md-size-30" v-if="tServiceAvailable">
              <span class="md-caption" v-show="unFinishCount === 0 && downloadableCount > 0">
                ※ 今回取得した登記情報のみダウンロードされます。過去に取得した登記情報は取得履歴からダウンロードしてください。
              </span>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout-item">
            <span class="md-caption">
              ※ 登記情報提供サービスの管理者ID、一時利用IDはご利用いただけません。<br/>
              ※ 登記情報提供サービスのIDについて、本サービスでの操作中は本サービスのみでご使用ください。<br/>
              本サービスで使用中に他サービスでご使用（登記情報提供サービスで直接使用することを含む）された場合 、登記情報取得等に影響する可能性がございます。<br/>
            </span>
            </div>
          </div>
        </div>
        <div class="md-layout-item md-size-5"></div>
        <div class="md-layout-item md-size-35 md-layout-options">
          <div class="md-subtitle">
            ※オプション
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
              <label>QRコード</label>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-radio v-for="(item, index) in Common.QRCode" :disabled="disabledRadioOptions()"
                        :key="'qrcode-radio-' + index" :value="item.code" v-model="form.qrCode"
              >{{ item.name }}
              </md-radio>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
              <label>共同担保目録</label>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-radio v-for="(item, index) in Common.JointSecurityInventory" :disabled="disabledRadioOptions()"
                        :key="'join-security-radio-' + index" :value="item.code" v-model="form.joinSecurity"
              >{{ item.name }}
              </md-radio>
            </div>
          </div>
          <div class="md-layout md-gutter">
            <div class="md-layout md-layout-item md-alignment-center-left md-size-30 md-small-size-100">
              <label>信託目録</label>
            </div>
            <div class="md-layout-item md-small-size-100">
              <md-radio v-for="(item, index) in Common.TrustInventory" :disabled="disabledRadioOptions()"
                        :key="'trust-radio-' + index" :value="item.code" v-model="form.trust"
              >{{ item.name }}
              </md-radio>
            </div>
          </div>
        </div>
      </div>

      <!-- ローディング-->
      <loading-spinner-overlay
          v-if="showConfirmOverride || showConfirmDuplicate || showConfirmGetRegistry || downloading || showCompleteModal"
          :background="'#CCCCCC'"></loading-spinner-overlay>
      <loading-spinner-overlay v-if="loadBuildingNumbers" :custom="true" :opacity="0.9" :background="'#D6D6D6'">
        <md-content class="md-layout-item md-loading md-loading-building-number">
          <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
          <p class="md-subheading">部屋数の多い大規模マンションなどでは、<br>家屋番号の表示に時間がかかる場合がございます。</p>
        </md-content>
      </loading-spinner-overlay>
      <loading-spinner-overlay v-if="loadRegistrations" :custom="true" :opacity="1.0" :background="'#FFFFFF'">
        <md-content class="md-layout-item md-loading">
          <p class="md-title">物件情報を調査しています。</p>
          <md-progress-spinner :md-diameter="30" :md-stroke="3" md-mode="indeterminate"></md-progress-spinner>
          <p class="md-subheading">※土地に対する家屋番号が多い場合は時間がかかる場合がございます</p>
        </md-content>
      </loading-spinner-overlay>
    </md-dialog-content>

    <confirm-modal :class="'md-dialog--small'"
                   :md-active.sync="showConfirmOverride"
                   :md-content="modelContentForOverride()"
                   md-title="登記情報取得の確認"
                   :md-confirm-text="'はい'"
                   :md-cancel-text="'いいえ'"
                   @md-cancel="onCancelOverride"
                   @md-confirm="onConfirmOverride"/>

    <confirm-modal :class="'md-dialog--small'"
                   :md-active.sync="showConfirmDuplicate"
                   :md-content="modelContentForDuplicate()"
                   md-title="登記情報取得の確認"
                   :selected-registries="selectedRegistries()"
                   :show-primary-button="false"
                   :md-cancel-text="'閉じる'"
                   @md-cancel="onCancelDuplicate"/>

    <confirm-modal :class="'md-dialog--small'"
                   :md-active.sync="showConfirmGetRegistry"
                   md-content="登記情報提供サービスの定める料金が発生します。<br />よろしいですか？<br /><span class='md-caption'>※提供できない登記情報が含まれていた場合、その分の料金は発生しません。</span>"
                   md-title="登記情報取得の確認"
                   :selected-registries="selectedRegistries()"
                   :has-warning="hasReacquisition"
                   :md-confirm-text="'OK'"
                   :md-cancel-text="'キャンセル'"
                   @md-cancel="onCancelGetRegistry"
                   @md-confirm="onConfirmGetRegistry"/>

    <progress-model :class="'md-dialog--small'"
                    :md-active.sync="downloading"
                    :title="'ダウンロード中'"
                    :downloading="downloading"
                    :download-progress="downloadProgress"
    ></progress-model>

    <complete-modal :class="'md-dialog--small'"
                    :md-active.sync="showCompleteModal"
                    :md-confirm-text="'OK'"
                    @md-confirm="showCompleteModal = false">
      問い合わせが完了しました。<br/>
      青字箇所(例：「<span class="text-link">{{ currentMonth() }}</span>」「<span class="text-link">取得不可</span>」)をクリックし、<br/>
      問い合わせ結果をご確認ください。
    </complete-modal>
  </md-dialog>
</template>

<script>
import LoadingSpinnerOverlay                                   from '../../../components/LoadingSpinnerOverlay';
import CommonMixin                                             from '../../../mixins/commonMixin';
import Common                                                  from '../../../modules/common';
import {apiClientWithUserToken as apiClient, apiList, apiTool} from '../../../modules/apiClient';
import {validationMixin}                                       from 'vuelidate';
import {requiredIf}                                            from 'vuelidate/lib/validators'
import Validation                                              from '../../../modules/validation';
import ConfirmModal                                            from '../../ConfirmModal';
import moment                                                  from 'moment-timezone';
import axios                                                   from "axios";
import ProgressModel                                           from "../../ProgressModal";
import DownloadPdfsMixin                                       from "../../../mixins/downloadPdfsMixin";
import CompleteModal                                           from "../../CompleteModal";

export default {
  name      : 'MapRegistrationDialog',
  components: {
    ProgressModel,
    ConfirmModal,
    LoadingSpinnerOverlay,
    CompleteModal,
  },
  mixins    : [validationMixin, CommonMixin, DownloadPdfsMixin],
  props     : {
    parcelNumber                : {
      type   : String,
      default: null,
    },
    multiParcelNumber           : {
      type   : Array,
      default: [],
    },
    registrationItem            : {
      type   : Object,
      default: null,
    },
    loadReObtainRegistrationInfo: {
      type   : Boolean,
      default: false,
    },
    mapInit                     : {
      type   : Object,
      default: null,
    },
    tServiceId                  : {
      type   : String,
      default: null,
    },
    isTrialUser                 : {
      type   : Boolean,
      default: true,
    },
  },
  data() {
    return {
      loadRegistrations              : false,
      loadBuildingNumbers            : false,
      loadedBuildingNumbers          : false,
      loadIncidents                  : false,
      showRegistrationDialog         : false,
      showConfirmGetRegistry         : false,
      hasReacquisition               : false,
      pdfTypeCheckChange             : null,
      showConfirmOverride            : false,
      showConfirmDuplicate           : false,
      showCompleteModal              : false,
      duplicateRegistrations         : [],
      tServiceAvailable              : false,
      tServiceAvailableMapAndDrawings: false,
      sendingRegistryInfo            : false,
      lotNumber                      : [],
      houseNumber                    : [],
      pdfErrorMessage                : null,
      form                           : {
        address                   : null,
        latitude                  : null,
        longitude                 : null,
        t_service_id              : null,
        password                  : null,
        hiddenPassword            : null,
        checkParcelWholeData      : [],
        checkParcelOwnerData      : [],
        checkParcelMap            : [],
        checkParcelLandSurveyMap  : [],
        checkParcelEasementDrawing: [],
        checkBuildingWholeData    : [],
        checkBuildingOwnerData    : [],
        checkBuildingDrawings     : [],
        pdfTypeSelected           : [],
        incidentLandSelected      : [],
        incidentEasementSelected  : [],
        incidentDrawingSelected   : [],
        qrCode                    : Common.QRCode.Wanted.code,
        joinSecurity              : Common.JointSecurityInventory.Wanted.code,
        trust                     : Common.TrustInventory.Wanted.code,
        validating                : false,
        incidentSelectedError     : false,
      },
      cancelToken                    : {
        parcelToBuildingNumber: null,
      },
      Common                         : Common,
      errors                         : {
        tServiceId      : {
          required: Validation.errorMessage(Validation.rules.required, 'tServiceID'),
        },
        password        : {
          required: Validation.errorMessage(Validation.rules.required, 'password'),
        },
        pdfTypeSelected : {
          required: Validation.errorMessage(Validation.rules.required, 'pdfTypeSelected'),
        },
        incidentSelected: {
          required: Validation.errorMessage(Validation.rules.incident, 'incidentSelected'),
        },
      },
      isHiddenPassword               : true,
      multiPointMode                 : false,
      selectAll                      : {
        OwnerData      : false,
        WholeData      : false,
        Map            : false,
        LandSurveyMap  : false,
        EasementDrawing: false,
      },
      unFinishCount                  : Common.defaultUnFinishCount,
      downloadableCount              : 0,
      hasSavePassword                : false,
    }
  },
  validations: {
    form: {
      t_service_id   : {
        required: requiredIf(function () {
          return this.isTrialUser && this.form.password;
        }),
      },
      password       : {
        required: requiredIf(function () {
          return !this.isTrialUser || (this.isTrialUser && this.form.t_service_id);
        }),
      },
      pdfTypeSelected: {
        required: requiredIf(function () {
          return this.form.checkParcelWholeData.length === 0 &&
              this.form.checkParcelOwnerData.length === 0 &&
              this.form.checkParcelMap.length === 0 &&
              this.form.checkParcelLandSurveyMap.length === 0 &&
              this.form.checkParcelEasementDrawing.length === 0 &&
              this.form.checkBuildingWholeData.length === 0 &&
              this.form.checkBuildingOwnerData.length === 0 &&
              this.form.checkBuildingDrawings.length === 0;
        }),
      },
    }
  },
  mounted() {
    this.getWindowInnerSize();
    window.addEventListener('resize', this.getWindowInnerSize, {passive: false});
    window.addEventListener('resize', this.houseNumberSyncWidth, {passive: false});
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getWindowInnerSize, {passive: false});
    window.removeEventListener('resize', this.houseNumberSyncWidth, {passive: false});
  },
  updated() {
    this.houseNumberSyncWidth();

    if (this.$refs['mdSelect']) {
      this.$refs['mdSelect'].forEach(mdSelect => {
        if (mdSelect.$el) {
          mdSelect.$el.validity = {};
        }
      });
    }
  },
  watch  : {
    'form.password'             : function (password) {
      this.form.hiddenPassword = '•'.repeat(password.length);
    },
    showRegistrationDialog      : function () {
      if (this.showRegistrationDialog) {
        this.loadTServiceIdFromStorage();
        this.loadPasswordFromStorage();
        this.showConfirmOverride    = false;
        this.showConfirmDuplicate   = false;
        this.showConfirmGetRegistry = false;
        this.unFinishCount          = 0;
      }
    },
    parcelNumber                : function () {
      if (this.parcelNumber && this.mapInit && !this.loadRegistrations) {
        this.showRegistrationDialog = true;
        this.multiPointMode         = false;
        this.fetchParcelNumber();
      }
    },
    multiParcelNumber           : function () {
      if (this.multiParcelNumber && this.multiParcelNumber.length > 0 && this.mapInit && !this.loadRegistrations) {
        this.showRegistrationDialog = true;
        this.multiPointMode         = true;
        this.fetchMultiParcelNumber();
      }
    },
    mapInit                     : function () {
      if (this.parcelNumber && this.mapInit && !this.loadRegistrations) {
        this.showRegistrationDialog = true;
        if (this.multiPointMode) {
          this.fetchMultiParcelNumber();
        } else {
          this.fetchParcelNumber();
        }
      }
      if (this.registrationItem && this.mapInit && !this.loadRegistrations) {
        this.showRegistrationDialog = true;
        this.multiPointMode         = false;
        this.fetchBuildingNumbers();
      }
    },
    pdfErrorMessage             : function () {
      if (this.pdfErrorMessage && this.pdfErrorMessage.length > 0) {
        this.$emit('displayPdfError', {message: this.pdfErrorMessage});
      }
      this.pdfErrorMessage = '';
    },
    errorMessages               : function () {
      if (this.errorMessages && this.errorMessages.length > 0) {
        this.$emit('displayErrors', {errorMessages: this.errorMessages});
      }
    },
    loadReObtainRegistrationInfo: function () {
      if (this.loadReObtainRegistrationInfo) {
        this.showRegistrationDialog = true;
        this.loadRegistrations      = true;
      } else if (this.mapInit != null) {
        this.loadRegistrations   = false;
        this.loadBuildingNumbers = false;
        this.loadIncidents       = false;
        this.sendingRegistryInfo = false;
        if (this.registrationItem !== null) {
          this.fetchRegistrations();
        } else {
          this.fetchParcelNumber();
        }
      }
    }
  },
  methods: {
    isSending() {
      return this.loadRegistrations ||
          this.loadBuildingNumbers ||
          this.loadIncidents ||
          this.sendingRegistryInfo ||
          (this.unFinishCount !== Common.defaultUnFinishCount && this.unFinishCount > 0);
    },

    disabledRadioOptions() {
      return (this.form.checkParcelWholeData.length === 0 && this.form.checkBuildingWholeData.length === 0) ||
          this.isSending();
    },

    disabledIncidentButton() {
      return (this.form.checkParcelLandSurveyMap.length === 0 &&
              this.form.checkParcelEasementDrawing.length === 0 &&
              this.form.checkBuildingDrawings.length === 0) ||
          this.isSending();
    },
    /**
     * 登記情報取得モーダルを閉じる
     */
    close() {
      if (this.cancelToken.parcelToBuildingNumber) {
        this.loadRegistrations   = false;
        this.loadBuildingNumbers = false;
        this.cancelToken.parcelToBuildingNumber.cancel();
      }
      this.$v.$reset();
      this.form.validating        = false;
      this.showRegistrationDialog = false;
      this.showCompleteModal      = false;
      this.loadedBuildingNumbers  = false;
      this.isHiddenPassword       = true;
      this.multiPointMode         = false;
      this.lotNumber              = [];
      this.houseNumber            = [];
      this.unFinishCount          = Common.defaultUnFinishCount;
      this.downloadableCount      = 0;
      this.$emit('exitMultiPointMode');
      this.$emit('close');
    },

    initCheckValues() {
      this.form.checkParcelWholeData       = [];
      this.form.checkParcelOwnerData       = [];
      this.form.checkParcelMap             = [];
      this.form.checkParcelLandSurveyMap   = [];
      this.form.checkParcelEasementDrawing = [];
      this.form.checkBuildingWholeData     = [];
      this.form.checkBuildingOwnerData     = [];
      this.form.checkBuildingDrawings      = [];
    },

    initLotNumber(parcelNumber) {
      const self                         = this;
      this.houseNumber                   = [];
      this.form.incidentLandSelected     = [];
      this.form.incidentEasementSelected = [];
      this.form.incidentDrawingSelected  = [];
      if (typeof parcelNumber == 'object') {
        this.lotNumber.push({
          v1_code      : parcelNumber.v1_code,
          pref         : parcelNumber.address.pref,
          city         : parcelNumber.address.city,
          large_section: parcelNumber.address.large_section,
          small_section: parcelNumber.address.small_section,
          parcel_number: parcelNumber.parcel_number,
          status       : self.generateListDefaultStatus(),
        });
      } else {
        this.lotNumber = [{
          v1_code      : this.mapInit.dataPoints.v1_code,
          pref         : this.mapInit.dataPoints.address.pref,
          city         : this.mapInit.dataPoints.address.city,
          large_section: this.mapInit.dataPoints.address.large_section,
          small_section: this.mapInit.dataPoints.address.small_section,
          parcel_number: parcelNumber ? parcelNumber : this.mapInit.dataPoints.parcel_number,
          status       : self.generateListDefaultStatus(),
        }];
      }
      this.lotNumber.forEach((number) => {
        this.form.incidentLandSelected[number.parcel_number]     = null;
        this.form.incidentEasementSelected[number.parcel_number] = null;
      });
    },

    fetchParcelNumber() {
      // Init form
      this.loadRegistrations = true;
      this.form.v1Code       = this.mapInit.dataPoints.v1_code;
      this.form.address      = this.mapInit.dataPoints.address;
      this.form.latitude     = this.mapInit.dataPoints.latitude;
      this.form.longitude    = this.mapInit.dataPoints.longitude;
      this.form.validating   = false;
      const self             = this;
      this.errorMessages     = [];
      const params           = {
        v1_code      : this.mapInit.dataPoints.v1_code,
        address      : this.mapInit.dataPoints.address,
        parcel_number: this.parcelNumber ? this.parcelNumber : this.mapInit.dataPoints.parcel_number,
      };
      apiClient.get(apiList.jon.parcel_number, {params: params})
          .then(response => {
            if (self.hasResponseErrors(response)) {
              self.close();
              return;
            }
            self.initCheckValues();
            self.initLotNumber(self.parcelNumber);
            const result                         = response.data;
            self.tServiceAvailable               = result.is_available === true;
            self.tServiceAvailableMapAndDrawings = result.availabilities.map_and_drawings === true;

            // これまで取得した登記情報の履歴を表示
            const registrations = result.registrations ?? [];
            if (registrations && registrations.length > 0) {
              let parcelRegistrations = registrations.filter(function (item, index) {
                return registrations.filter(function (prevItem, prevIndex) {
                  return prevIndex < index
                      && item.number === prevItem.number
                      && item.number_type === prevItem.number_type
                      && item.pdf_type === prevItem.pdf_type
                      && item.requested_at < prevItem.requested_at;
                }).length === 0;
              });
              parcelRegistrations.map(function (parcelNumberResult) {
                self.lotNumber.map(function (item, index) {
                  if (item.parcel_number === parcelNumberResult.number &&
                      Common.numberTypeParcel === parcelNumberResult.number_type &&
                      item.status[parcelNumberResult.pdf_type]) {
                    item.status[parcelNumberResult.pdf_type].status         = parcelNumberResult.status ?? 1;
                    item.status[parcelNumberResult.pdf_type].id             = parcelNumberResult.id;
                    item.status[parcelNumberResult.pdf_type].label          = parcelNumberResult.label;
                    item.status[parcelNumberResult.pdf_type].pre_signed_url = parcelNumberResult.pre_signed_url;
                    item.status[parcelNumberResult.pdf_type].requested_at   = parcelNumberResult.requested_at;
                    item.status[parcelNumberResult.pdf_type].error_code     = parcelNumberResult.error_code;
                    item.status[parcelNumberResult.pdf_type].message        = parcelNumberResult.message;
                    item.status[parcelNumberResult.pdf_type].summary        = parcelNumberResult.summary;
                    item.status[parcelNumberResult.pdf_type].token          = parcelNumberResult.token;
                  }
                });
              });
            }
          })
          .catch(error => {
            self.errorMessages = [error.message];
            self.close();
          })
          .finally(() => {
            self.loadRegistrations = false;
          });
    },

    fetchMultiParcelNumber() {
      // Init form
      this.loadRegistrations = true;
      this.form.v1Code       = this.mapInit.dataPoints.v1_code;
      this.form.address      = this.mapInit.dataPoints.address;
      this.form.latitude     = this.mapInit.dataPoints.latitude;
      this.form.longitude    = this.mapInit.dataPoints.longitude;
      this.form.validating   = false;
      const self             = this;
      this.errorMessages     = [];
      let promisePointArray  = self.multiParcelNumber.map((parcelNumber) => {
        const params = {
          v1_code      : parcelNumber.v1_code,
          address      : parcelNumber.address,
          parcel_number: parcelNumber.parcel_number,
        };
        return apiClient.get(apiList.jon.parcel_number, {params: params});
      });

      return new Promise((resolve, reject) => {
        axios
            .all(promisePointArray)
            .then(axios.spread((...responses) => {
              responses.map((response, index) => {
                if (self.hasResponseErrors(response)) {
                  self.close();
                  return;
                }
                self.initCheckValues();
                self.initLotNumber(self.multiParcelNumber[index]);
                const result                         = response.data;
                self.tServiceAvailable               = result.is_available === true;
                self.tServiceAvailableMapAndDrawings = result.availabilities.map_and_drawings === true;

                // これまで取得した登記情報の履歴を表示
                const registrations = result.registrations ?? [];
                if (registrations && registrations.length > 0) {
                  let parcelRegistrations = registrations.filter(function (item, index) {
                    return registrations.filter(function (prevItem, prevIndex) {
                      return prevIndex < index
                          && item.number === prevItem.number
                          && item.number_type === prevItem.number_type
                          && item.pdf_type === prevItem.pdf_type
                          && item.requested_at < prevItem.requested_at;
                    }).length === 0;
                  });
                  parcelRegistrations.map(function (parcelNumberResult) {
                    self.lotNumber.map(function (item, index) {
                      if (item.parcel_number === parcelNumberResult.number &&
                          Common.numberTypeParcel === parcelNumberResult.number_type &&
                          item.status[parcelNumberResult.pdf_type]) {
                        item.status[parcelNumberResult.pdf_type].status         = parcelNumberResult.status ?? 1;
                        item.status[parcelNumberResult.pdf_type].id             = parcelNumberResult.id;
                        item.status[parcelNumberResult.pdf_type].label          = parcelNumberResult.label;
                        item.status[parcelNumberResult.pdf_type].pre_signed_url = parcelNumberResult.pre_signed_url;
                        item.status[parcelNumberResult.pdf_type].requested_at   = parcelNumberResult.requested_at;
                        item.status[parcelNumberResult.pdf_type].error_code     = parcelNumberResult.error_code;
                        item.status[parcelNumberResult.pdf_type].message        = parcelNumberResult.message;
                        item.status[parcelNumberResult.pdf_type].summary        = parcelNumberResult.summary;
                        item.status[parcelNumberResult.pdf_type].token          = parcelNumberResult.token;
                      }
                    });
                  });
                }
              });
              resolve();
            }))
            .catch(error => {
              self.errorMessages = [error.message];
              self.close();
              reject(error);
            })
            .finally(() => {
              self.loadRegistrations = false;
            });
      });
    },

    fetchRegistrations() {
      if (this.registrationItem === null) {
        return;
      }

      const self               = this;
      this.loadRegistrations   = true;
      this.multiPointMode      = false;
      this.loadBuildingNumbers = true;
      this.lotNumber           = [];
      this.errorMessages       = [];
      this.form.v1Code         = this.mapInit.dataPoints.v1_code;
      this.form.address        = this.mapInit.dataPoints.address;
      this.form.latitude       = this.mapInit.dataPoints.latitude;
      this.form.longitude      = this.mapInit.dataPoints.longitude;
      let param                = {
        v1_code                     : this.registrationItem.v1_code,
        address                     : this.mapInit.dataPoints.address,
        parcel_number               : this.registrationItem.number,
        unnecessary_building_numbers: 1,
      };
      let promisePointArray    = [apiClient.get(apiList.jon.parcel_to_building_number, {params: param})];

      return new Promise(() => {
        axios
            .all(promisePointArray)
            .then(axios.spread((...responses) => {
                  self.houseNumber = [];
                  responses.map((response, index) => {
                    if (self.hasResponseErrors(response)) {
                      return;
                    }
                    if (self.hasNotAvailableRequests(response)) {
                      // Tサービス連携API（登記情報提供サービス）が利用不可の場合はエラーを返す
                      self.errorMessages = [Common.messages.registration.not_available];
                      return;
                    }

                    const result                                                    = response.data;
                    self.form.incidentDrawingSelected                               = [];
                    self.houseNumber                                                = [];
                    self.loadedBuildingNumbers                                      = true;
                    self.tServiceAvailable                                          = result.is_available === true;
                    self.tServiceAvailableMapAndDrawings                            = result.availabilities.map_and_drawings === true;
                    self.houseNumber                                                = [{
                      based_at     : this.registrationItem.based_at,
                      v1_code      : this.registrationItem.v1_code,
                      pref         : result.address.pref,
                      city         : result.address.city,
                      large_section: result.address.large_section,
                      small_section: result.address.small_section,
                      number       : this.registrationItem.number,
                      status       : self.generateBuildingListDefaultStatus(),
                    }];
                    self.form.incidentDrawingSelected[this.registrationItem.number] = null;

                    // これまで取得した登記情報の履歴を表示
                    const registrations = result.registrations ?? [];
                    if (registrations && registrations.length > 0) {
                      let parcelRegistrations = registrations.filter(function (item, index) {
                        return registrations.filter(function (prevItem, prevIndex) {
                          return prevIndex < index
                              && item.number === prevItem.number
                              && item.number_type === prevItem.number_type
                              && item.pdf_type === prevItem.pdf_type
                              && item.requested_at < prevItem.requested_at;
                        }).length === 0;
                      });
                      parcelRegistrations.map(function (parcelNumberResult) {
                        self.houseNumber.map(function (item, index) {
                          if (item.number === parcelNumberResult.number &&
                              Common.numberTypeBuilding === parcelNumberResult.number_type &&
                              item.status[parcelNumberResult.pdf_type]) {
                            item.status[parcelNumberResult.pdf_type].status         = parcelNumberResult.status ?? 1;
                            item.status[parcelNumberResult.pdf_type].id             = parcelNumberResult.id;
                            item.status[parcelNumberResult.pdf_type].label          = parcelNumberResult.label;
                            item.status[parcelNumberResult.pdf_type].pre_signed_url = parcelNumberResult.pre_signed_url;
                            item.status[parcelNumberResult.pdf_type].requested_at   = parcelNumberResult.requested_at;
                            item.status[parcelNumberResult.pdf_type].error_code     = parcelNumberResult.error_code;
                            item.status[parcelNumberResult.pdf_type].message        = parcelNumberResult.message;
                            item.status[parcelNumberResult.pdf_type].summary        = parcelNumberResult.summary;
                            item.status[parcelNumberResult.pdf_type].token          = parcelNumberResult.token;
                          }
                        });
                      });
                    }
                  })
                })
            )
            .catch(error => {
              self.errorMessages = [error.message];
            })
            .finally(() => {
              self.loadRegistrations   = false;
              self.loadBuildingNumbers = false;
              self.houseNumberSyncWidth();
            });
      });
    },

    /**
     * 「家屋番号を表示」ボタン
     *  地番に紐づく家屋番号一覧を取得する
     *
     * @returns {Promise<unknown>}
     */
    fetchBuildingNumbers() {
      this.loadBuildingNumbers                = true;
      const self                              = this;
      this.errorMessages                      = [];
      let param                               = {
        v1_code      : this.mapInit.dataPoints.v1_code,
        address      : this.mapInit.dataPoints.address,
        parcel_number: this.parcelNumber ? this.parcelNumber : this.mapInit.dataPoints.parcel_number,
      };
      this.cancelToken.parcelToBuildingNumber = apiTool.cancelToken();
      let promisePointArray                   = [apiClient.get(apiList.jon.parcel_to_building_number, {
        params     : param,
        timeout    : Common.buildingNumbersTimeout,
        cancelToken: this.cancelToken.parcelToBuildingNumber.token
      })];

      if (self.multiPointMode) {
        promisePointArray                 = self.multiParcelNumber.map((parcelNumber) => {
          const params = {
            v1_code      : parcelNumber.v1_code,
            address      : parcelNumber.address,
            parcel_number: parcelNumber.parcel_number,
          };
          return apiClient.get(apiList.jon.parcel_to_building_number, {
            params     : params,
            timeout    : Common.buildingNumbersTimeout,
            cancelToken: self.cancelToken.parcelToBuildingNumber.token
          });
        });
        self.form.incidentDrawingSelected = [];
        self.houseNumber                  = [];
      }

      return new Promise(() => {
        axios
            .all(promisePointArray)
            .then(axios.spread((...responses) => {
                  self.houseNumber = [];
                  responses.map((response, index) => {

                    if (self.hasResponseErrors(response)) {
                      return;
                    }
                    if (self.hasNotAvailableRequests(response)) {
                      // Tサービス連携API（登記情報提供サービス）が利用不可の場合はエラーを返す
                      self.errorMessages = [Common.messages.registration.not_available];
                      return;
                    }

                    if (!self.multiPointMode) {
                      self.form.incidentDrawingSelected = [];
                      self.houseNumber                  = [];
                    }
                    const result                         = response.data;
                    self.tServiceAvailable               = result.is_available === true;
                    self.tServiceAvailableMapAndDrawings = result.availabilities.map_and_drawings === true;
                    const buildingNumbers                = result['building_numbers'];
                    self.loadedBuildingNumbers           = true;
                    if (buildingNumbers && buildingNumbers.length > 0) {
                      const houseNumber = buildingNumbers.filter(function (item, index) {
                        return buildingNumbers.filter(function (prevItem, prevIndex) {
                          return prevIndex < index && item.number === prevItem.number;
                        }).length === 0;
                      }).sort((a, b) => {
                        const aParts = a.number.replace(/[^0-9A-Z-/]/g, "0").split(/([0-9]+)/);
                        const bParts = b.number.replace(/[^0-9A-Z-/]/g, "0").split(/([0-9]+)/);

                        for (let i = 0; i < Math.min(aParts.length, bParts.length); i++) {
                          // undefinedは小さいとみなす
                          if (aParts[i] === '' && bParts[i] !== '') return -1;
                          if (aParts[i] !== '' && bParts[i] === '') return 1;
                          if (aParts[i] === '' && bParts[i] === '') continue;

                          const aParse = parseInt(aParts[i], 10);
                          const bParse = parseInt(bParts[i], 10);

                          // 型が異なる場合、数値は文字列よりも小さいとみなす
                          if (isNaN(aParse) ^ isNaN(bParse)) {
                            return isNaN(aParse) ? -1 : 1;
                          }

                          if (!isNaN(aParse) && !isNaN(bParse)) {
                            // 同じ型の場合は通常の比較
                            if (aParts[i] !== bParts[i] && aParse === bParse) {
                              if (aParts[i] < bParts[i]) return -1;
                              if (aParts[i] > bParts[i]) return 1;
                            }
                            if (aParse < bParse) return -1;
                            if (aParse > bParse) return 1;
                          }

                          if (aParts[i] < bParts[i]) return -1;
                          if (aParts[i] > bParts[i]) return 1;
                        }
                        return aParts.length <= bParts.length ? -1 : 1;
                      });
                      houseNumber.forEach(v => {
                        v.status                                    = self.generateBuildingListDefaultStatus();
                        self.form.incidentDrawingSelected[v.number] = null;
                      });
                      self.houseNumber.push(...houseNumber);
                    } else {
                      self.errorMessages = [Common.messages.map.buildingNumberNotFound];
                      return;
                    }
                    // これまで取得した登記情報の履歴を表示
                    const registrations = result.registrations ?? [];
                    if (registrations && registrations.length > 0) {
                      let parcelRegistrations = registrations.filter(function (item, index) {
                        return registrations.filter(function (prevItem, prevIndex) {
                          return prevIndex < index
                              && item.number === prevItem.number
                              && item.number_type === prevItem.number_type
                              && item.pdf_type === prevItem.pdf_type
                              && item.requested_at < prevItem.requested_at;
                        }).length === 0;
                      });
                      parcelRegistrations.map(function (parcelNumberResult) {
                        self.houseNumber.map(function (item, index) {
                          if (item.number === parcelNumberResult.number &&
                              Common.numberTypeBuilding === parcelNumberResult.number_type &&
                              item.status[parcelNumberResult.pdf_type]) {
                            item.status[parcelNumberResult.pdf_type].status         = parcelNumberResult.status ?? 1;
                            item.status[parcelNumberResult.pdf_type].id             = parcelNumberResult.id;
                            item.status[parcelNumberResult.pdf_type].label          = parcelNumberResult.label;
                            item.status[parcelNumberResult.pdf_type].pre_signed_url = parcelNumberResult.pre_signed_url;
                            item.status[parcelNumberResult.pdf_type].requested_at   = parcelNumberResult.requested_at;
                            item.status[parcelNumberResult.pdf_type].error_code     = parcelNumberResult.error_code;
                            item.status[parcelNumberResult.pdf_type].message        = parcelNumberResult.message;
                            item.status[parcelNumberResult.pdf_type].summary        = parcelNumberResult.summary;
                            item.status[parcelNumberResult.pdf_type].token          = parcelNumberResult.token;
                          }
                        });
                      });
                    }
                  })
                })
            )
            .catch(error => {
              if (error.message) {
                self.errorMessages = [error.message];
              }
            })
            .finally(() => {
              self.loadRegistrations   = false;
              self.loadBuildingNumbers = false;
              self.houseNumberSyncWidth();
            });
      });
    },

    fetchIncidents() {
      const self         = this;
      let conditions     = [];
      self.loadIncidents = false;
      self.lotNumber.forEach(number => {
        if (self.form.checkParcelLandSurveyMap.filter(numberLand => numberLand === number.parcel_number).length > 0) {
          self.loadIncidents                                           = true;
          number.status[Common.pdfTypeLandSurveyMap].incidents.loading = true;
          number.status[Common.pdfTypeLandSurveyMap].incidents.list    = [];
          conditions.push({
            v1_code    : number.v1_code,
            number     : number.parcel_number,
            number_type: Common.numberTypeParcel,
            pdf_type   : Common.pdfTypeLandSurveyMap,
          });
        }
        if (self.form.checkParcelEasementDrawing.filter(numberEasement => numberEasement === number.parcel_number).length > 0) {
          self.loadIncidents                                             = true;
          number.status[Common.pdfTypeEasementDrawing].incidents.loading = true;
          number.status[Common.pdfTypeEasementDrawing].incidents.list    = [];
          conditions.push({
            v1_code    : number.v1_code,
            number     : number.parcel_number,
            number_type: Common.numberTypeParcel,
            pdf_type   : Common.pdfTypeEasementDrawing,
          });
        }
      });
      self.houseNumber.forEach(number => {
        if (self.form.checkBuildingDrawings.filter(numberDrawing => numberDrawing === number.number).length) {
          self.loadIncidents                                             = true;
          number.status[Common.pdfTypeBuildingDrawing].incidents.loading = true;
          number.status[Common.pdfTypeBuildingDrawing].incidents.list    = [];
          conditions.push({
            v1_code    : number.v1_code,
            number     : number.number,
            number_type: Common.numberTypeBuilding,
            pdf_type   : Common.pdfTypeBuildingDrawing,
          });
        }
      });
      if (self.loadIncidents === false) {
        return;
      }
      this.fetchConfirmAvailable();
      this.fetchIncident(conditions);
    },

    fetchConfirmAvailable() {
      const self = this;
      apiClient.get(apiList.jon.confirm_available)
          .then(response => {
            self.tServiceAvailableMapAndDrawings = response.data.availabilities.map_and_drawings === true;
          })
          .catch(error => {
            self.errorMessages = [error.message];
          });
    },

    fetchIncident(conditions) {
      const self = this;
      apiClient.post(apiList.jon.parcel_and_building_to_incident, {conditions: conditions})
          .then(response => {
            if (self.hasResponseErrors(response)) {
              return;
            }
            if (self.hasNotAvailableMapAndDrawRequests(response)) {
              // Tサービス連携API（登記情報提供サービス）が利用不可の場合はエラーを返す
              self.errorMessages = [Common.messages.registration.not_available_map_and_draw];
              return;
            }
            let hasIncident                      = false;
            const incidents                      = response.data.incidents;
            self.tServiceAvailable               = response.data.is_available === true;
            self.tServiceAvailableMapAndDrawings = response.data.availabilities.map_and_drawings === true;
            const lotNumberPdfTypes              = [Common.pdfTypeLandSurveyMap, Common.pdfTypeEasementDrawing];
            self.lotNumber.forEach(number => {
              lotNumberPdfTypes.forEach(pdfType => {
                if (number.status[pdfType].incidents.loading === false) {
                  return;
                }
                number.status[pdfType].incidents.loading = false;
                if (incidents && incidents.length > 0) {
                  const incident                        = incidents.filter(incident => incident.number_type === Common.numberTypeParcel && incident.number === number.parcel_number && pdfType === incident.pdf_type);
                  number.status[pdfType].incidents.list = incident.length > 0 ? incident[0].list : [];
                  if (number.status[pdfType].incidents.list.length > 0) {
                    hasIncident = true;
                  }
                } else {
                  number.status[pdfType].incidents.list = [];
                }
              });
            });
            self.houseNumber.forEach(number => {
              const pdfType = Common.pdfTypeBuildingDrawing;
              if (number.status[pdfType].incidents.loading === false) {
                return;
              }
              number.status[pdfType].incidents.loading = false;
              if (incidents && incidents.length > 0) {
                const incident                        = incidents.filter(incident => incident.number_type === Common.numberTypeBuilding && incident.number === number.number && pdfType === incident.pdf_type);
                number.status[pdfType].incidents.list = incident.length > 0 ? incident[0].list : [];
                if (number.status[pdfType].incidents.list.length > 0) {
                  hasIncident = true;
                }
              } else {
                number.status[pdfType].incidents.list = [];
              }
            });
          })
          .catch(error => {
            self.errorMessages = [error.message];
          })
          .finally(() => {
            self.lotNumber.forEach(number => {
              number.status[Common.pdfTypeLandSurveyMap].incidents.loading   = false;
              number.status[Common.pdfTypeEasementDrawing].incidents.loading = false;
              if (number.status[Common.pdfTypeLandSurveyMap].incidents.list && number.status[Common.pdfTypeLandSurveyMap].incidents.list.length === 0) {
                const removeIndex = self.form.checkParcelLandSurveyMap.indexOf(number.parcel_number);
                if (removeIndex > -1) {
                  self.form.checkParcelLandSurveyMap.splice(removeIndex, 1);
                }
              }
              if (number.status[Common.pdfTypeEasementDrawing].incidents.list && number.status[Common.pdfTypeEasementDrawing].incidents.list.length === 0) {
                const removeIndex = self.form.checkParcelEasementDrawing.indexOf(number.parcel_number);
                if (removeIndex > -1) {
                  self.form.checkParcelEasementDrawing.splice(removeIndex, 1);
                }
              }
            });
            self.houseNumber.forEach(number => {
              number.status[Common.pdfTypeBuildingDrawing].incidents.loading = false;
              if (number.status[Common.pdfTypeBuildingDrawing].incidents.list && number.status[Common.pdfTypeBuildingDrawing].incidents.list.length === 0) {
                const removeIndex = self.form.checkBuildingDrawings.indexOf(number.number);
                if (removeIndex > -1) {
                  self.form.checkBuildingDrawings.splice(removeIndex, 1);
                }
              }
            });
            self.loadIncidents = false;
          });
    },

    getTServiceLocalStorageKey() {
      const account = Common.getCurrentUserInfo();
      return Common.localStorageKeys.user.tServiceTrial + '_' + account.corporation.id + '_' + account.id;
    },

    getTServicePasswordLocalStorageKey() {
      return Common.localStorageKeys.user.tServicePassword + '_' + (this.tServiceId ?? this.form.t_service_id);
    },

    /**
     * 登記情報取得モーダル内の一覧初期値
     */
    generateListDefaultStatus() {
      return {
        1: {
          id            : null,
          label         : null,
          pdf_type      : 1,
          token         : null,
          status        : null,
          requested_at  : null,
          pre_signed_url: null,
          error_code    : null,
          message       : null,
          summary       : null,
        },
        2: {
          id            : null,
          label         : null,
          pdf_type      : 2,
          token         : null,
          status        : null,
          requested_at  : null,
          pre_signed_url: null,
          error_code    : null,
          message       : null,
          summary       : null,
        },
        3: {
          id            : null,
          label         : null,
          pdf_type      : 3,
          token         : null,
          status        : null,
          requested_at  : null,
          pre_signed_url: null,
          error_code    : null,
          message       : null,
          summary       : null,
        },
        4: {
          id            : null,
          label         : null,
          pdf_type      : 4,
          token         : null,
          status        : null,
          requested_at  : null,
          pre_signed_url: null,
          error_code    : null,
          message       : null,
          summary       : null,
          incidents     : {
            loading: false,
            list   : null,
          },
        },
        5: {
          id            : null,
          label         : null,
          pdf_type      : 5,
          token         : null,
          status        : null,
          requested_at  : null,
          pre_signed_url: null,
          error_code    : null,
          message       : null,
          summary       : null,
          incidents     : {
            loading: false,
            list   : null,
          },
        },
      };
    },
    /**
     * Init status values for building numbers
     */
    generateBuildingListDefaultStatus() {
      return {
        1: {
          id            : null,
          label         : null,
          pdf_type      : 1,
          token         : null,
          status        : null,
          requested_at  : null,
          pre_signed_url: null,
          error_code    : null,
          message       : null,
          summary       : null,
        },
        2: {
          id            : null,
          label         : null,
          pdf_type      : 2,
          token         : null,
          status        : null,
          requested_at  : null,
          pre_signed_url: null,
          error_code    : null,
          message       : null,
          summary       : null,
        },
        6: {
          id            : null,
          label         : null,
          pdf_type      : 6,
          token         : null,
          status        : null,
          requested_at  : null,
          pre_signed_url: null,
          error_code    : null,
          message       : null,
          summary       : null,
          incidents     : {
            loading: false,
            list   : null,
          },
        },
      };
    },
    /**
     * Toggle select all whole data
     */
    toggleWholeData() {
      const self        = this;
      const selectedAll = self.selectAllWholeData();
      self.form.checkParcelWholeData.splice(0, self.form.checkParcelWholeData.length);
      self.form.checkBuildingWholeData.splice(0, self.form.checkBuildingWholeData.length);
      if (self.selectAll.WholeData) {
        self.selectAll.WholeData = false;
        return;
      }
      if (!selectedAll) {
        self.lotNumber.forEach(function (item) {
          self.form.checkParcelWholeData.push(item.parcel_number);
        });
        self.houseNumber.forEach(function (item) {
          self.form.checkBuildingWholeData.push(item.number);
        });
        self.pdfTypeCheckChange = Common.pdfTypeWholeData;
        if (self.lotNumber.filter((lot) => lot.status[Common.pdfTypeWholeData].pre_signed_url).length) {
          this.showConfirmOverride = true;
          return;
        }
        if (self.houseNumber.filter((house) => house.status[Common.pdfTypeWholeData].pre_signed_url).length) {
          this.showConfirmOverride = true;
        }
      }
    },
    /**
     * Check if select all whole data
     */
    selectAllWholeData() {
      if (this.lotNumber.length === 0) {
        return false;
      }
      return this.form.checkParcelWholeData.length === this.lotNumber.length &&
          this.form.checkBuildingWholeData.length === this.houseNumber.length;
    },
    /**
     * Toggle select all owner data
     */
    toggleOwnerData() {
      const self        = this;
      const selectedAll = self.selectAllOwnerData();
      self.form.checkParcelOwnerData.splice(0, self.form.checkParcelOwnerData.length);
      self.form.checkBuildingOwnerData.splice(0, self.form.checkBuildingOwnerData.length);
      if (self.selectAll.OwnerData) {
        self.selectAll.OwnerData = false;
        return;
      }
      if (!selectedAll) {
        self.lotNumber.forEach(function (item) {
          self.form.checkParcelOwnerData.push(item.parcel_number);
        });
        self.houseNumber.forEach(function (item) {
          self.form.checkBuildingOwnerData.push(item.number);
        });
        self.pdfTypeCheckChange = Common.pdfTypeOwnerData;
        if (self.lotNumber.filter((lot) => lot.status[Common.pdfTypeOwnerData].pre_signed_url).length) {
          this.showConfirmOverride = true;
          return;
        }
        if (self.houseNumber.filter((house) => house.status[Common.pdfTypeOwnerData].pre_signed_url).length) {
          this.showConfirmOverride = true;
        }
      }
    },
    /**
     * Check if select all owner data
     */
    selectAllOwnerData() {
      if (this.lotNumber.length === 0) {
        return false;
      }
      return this.form.checkParcelOwnerData.length === this.lotNumber.length &&
          this.form.checkBuildingOwnerData.length === this.houseNumber.length;
    },
    /**
     * Toggle select all map
     */
    toggleMap() {
      const self        = this;
      const selectedAll = self.selectAllMap();
      self.form.checkParcelMap.splice(0, self.form.checkParcelMap.length);
      if (self.selectAll.Map) {
        self.selectAll.Map = false;
        return;
      }
      if (!selectedAll) {
        self.lotNumber.forEach(function (item) {
          self.form.checkParcelMap.push(item.parcel_number);
        });
        self.pdfTypeCheckChange = Common.pdfTypeMap;
        if (self.lotNumber.filter((lot) => lot.status[Common.pdfTypeMap].pre_signed_url).length) {
          this.showConfirmOverride = true;
        }
      }
    },
    /**
     * Check if select all map
     */
    selectAllMap() {
      if (this.lotNumber.length === 0) {
        return false;
      }
      return this.form.checkParcelMap.length === this.lotNumber.length;
    },
    /**
     * Toggle select all land survey map and building drawing
     */
    toggleLandSurveyMap() {
      const self        = this;
      const selectedAll = self.selectAllLandSurveyMap();
      self.form.checkParcelLandSurveyMap.splice(0, self.form.checkParcelLandSurveyMap.length);
      self.form.checkBuildingDrawings.splice(0, self.form.checkBuildingDrawings.length);
      if (self.selectAll.LandSurveyMap) {
        self.selectAll.LandSurveyMap = false;
        return;
      }
      if (!selectedAll) {
        self.lotNumber.forEach(function (item) {
          self.form.checkParcelLandSurveyMap.push(item.parcel_number);
        });
        self.houseNumber.forEach(function (item) {
          self.form.checkBuildingDrawings.push(item.number);
        });
        self.pdfTypeCheckChange = Common.pdfTypeLandSurveyMap;
        if (self.lotNumber.filter((lot) => lot.status[Common.pdfTypeLandSurveyMap].pre_signed_url).length) {
          this.showConfirmOverride = true;
          return;
        }
        if (self.houseNumber.filter((house) => house.status[Common.pdfTypeBuildingDrawing].pre_signed_url).length) {
          this.showConfirmOverride = true;
        }
      }
    },
    /**
     * Check if select all owner data
     */
    selectAllLandSurveyMap() {
      if (this.lotNumber.length === 0) {
        return false;
      }
      return this.form.checkParcelLandSurveyMap.length === this.lotNumber.length &&
          this.form.checkBuildingDrawings.length === this.houseNumber.length;
    },
    /**
     * Toggle select all easement drawing
     */
    toggleEasementDrawing() {
      const self        = this;
      const selectedAll = self.selectAllEasementDrawing();
      self.form.checkParcelEasementDrawing.splice(0, self.form.checkParcelEasementDrawing.length);
      if (self.selectAll.EasementDrawing) {
        self.selectAll.EasementDrawing = false;
        return;
      }
      if (!selectedAll) {
        self.lotNumber.forEach(function (item) {
          self.form.checkParcelEasementDrawing.push(item.parcel_number);
        });
        self.pdfTypeCheckChange = Common.pdfTypeEasementDrawing;
        if (self.lotNumber.filter((lot) => lot.status[Common.pdfTypeEasementDrawing].pre_signed_url).length) {
          this.showConfirmOverride = true;
        }
      }
    },
    /**
     * Check if select all easement drawing
     */
    selectAllEasementDrawing() {
      if (this.lotNumber.length === 0) {
        return false;
      }
      return this.form.checkParcelEasementDrawing.length === this.lotNumber.length;
    },
    /**
     * Validate form
     */
    validateRegistryForm() {
      this.form.validating = true;
      this.validateIncidents();
      this.$v.$touch();
      if (this.$v.$invalid || this.form.incidentSelectedError) {
        return;
      }
      this.detectDuplicateRequest();
    },
    /**
     *
     * @returns {string}
     */
    modelContentForOverride() {
      return '取得済みの登記情報が存在します。<br />除外しますか？'
          + (this.isTrialUser ? '<br /><br /><span class="md-caption">※無料トライアルではサンプルpdfを表示している関係で<br />過去に取得をしていない場合も、この表示がされる場合があります。</span>' : '');
    },
    /**
     * On cancel override registry
     */
    onCancelOverride() {
      this.showConfirmOverride = false;
      this.validateIncidents();
    },
    /**
     * On confirm override
     */
    onConfirmOverride() {
      const self               = this;
      self.showConfirmOverride = false;
      switch (self.pdfTypeCheckChange) {
        case Common.pdfTypeWholeData:
          self.form.checkParcelWholeData.splice(0, self.form.checkParcelWholeData.length);
          self.form.checkBuildingWholeData.splice(0, self.form.checkBuildingWholeData.length);
          self.form.checkParcelWholeData.push(...self.lotNumber
              .filter((item) => !item.status[Common.pdfTypeWholeData].pre_signed_url)
              .map((item) => item.parcel_number)
          );
          self.form.checkBuildingWholeData.push(...self.houseNumber
              .filter((item) => !item.status[Common.pdfTypeWholeData].pre_signed_url)
              .map((item) => item.number)
          );
          if (self.form.checkParcelWholeData.length || self.form.checkBuildingWholeData.length) {
            self.selectAll.WholeData = true;
          }
          break;
        case Common.pdfTypeOwnerData:
          self.form.checkParcelOwnerData.splice(0, self.form.checkParcelOwnerData.length);
          self.form.checkBuildingOwnerData.splice(0, self.form.checkBuildingOwnerData.length);
          self.form.checkParcelOwnerData.push(...self.lotNumber
              .filter((item) => !item.status[Common.pdfTypeOwnerData].pre_signed_url)
              .map((item) => item.parcel_number)
          );
          self.form.checkBuildingOwnerData.push(...self.houseNumber
              .filter((item) => !item.status[Common.pdfTypeOwnerData].pre_signed_url)
              .map((item) => item.number)
          );
          if (self.form.checkParcelOwnerData.length || self.form.checkBuildingOwnerData.length) {
            self.selectAll.OwnerData = true;
          }
          break;
        case Common.pdfTypeMap:
          self.form.checkParcelMap.splice(0, self.form.checkParcelMap.length);
          self.form.checkParcelMap.push(...self.lotNumber
              .filter((item) => !item.status[Common.pdfTypeMap].pre_signed_url)
              .map((item) => item.parcel_number)
          );
          if (self.form.checkParcelMap.length) {
            self.selectAll.Map = true;
          }
          break;
        case Common.pdfTypeLandSurveyMap:
          self.form.checkParcelLandSurveyMap.splice(0, self.form.checkParcelLandSurveyMap.length);
          self.form.checkBuildingDrawings.splice(0, self.form.checkBuildingDrawings.length);
          self.form.checkParcelLandSurveyMap.push(...self.lotNumber
              .filter((item) => !item.status[Common.pdfTypeLandSurveyMap].pre_signed_url)
              .map((item) => item.parcel_number)
          );
          self.form.checkBuildingDrawings.push(...self.houseNumber
              .filter((item) => !item.status[Common.pdfTypeBuildingDrawing].pre_signed_url)
              .map((item) => item.number)
          );
          if (self.form.checkParcelLandSurveyMap.length || self.form.checkBuildingDrawings.length) {
            self.selectAll.LandSurveyMap = true;
          }
          break;
        case Common.pdfTypeEasementDrawing:
          self.form.checkParcelEasementDrawing.splice(0, self.form.checkParcelEasementDrawing.length);
          self.form.checkParcelEasementDrawing.push(...self.lotNumber
              .filter((item) => !item.status[Common.pdfTypeEasementDrawing].pre_signed_url)
              .map((item) => item.parcel_number)
          );
          if (self.form.checkParcelEasementDrawing.length) {
            self.selectAll.EasementDrawing = true;
          }
          break;
        default:
          break;
      }
    },
    /**
     *
     * @returns {string}
     */
    modelContentForDuplicate() {
      const duplicateList = this.duplicateRegistrations.map(registration => {
        return registration.label;
      });

      return '取得中の登記情報が含まれております。取得が完了するまでお待ちください。<br /><br />'
          + '<b>取得中の登記情報</b>'
          + '<pre>' + duplicateList.join('\n') + '</pre>';
    },
    /**
     * 同一条件の登記情報が取得中か確認する
     */
    detectDuplicateRequest() {
      const self               = this;
      const params             = self.createRegistryInformationParams(null);
      self.sendingRegistryInfo = true;
      apiClient.post(apiList.jon.detect_duplicate_request, params)
          .then(response => {
            if (self.hasDuplicateRequests(response)) {
              self.duplicateRegistrations = response.data.duplicate;
              self.showConfirmDuplicate   = true;
              return;
            }

            self.checkHasReacquisition();
            self.form.validating        = false;
            self.showConfirmGetRegistry = true;
          })
          .catch(error => {
            self.errorMessages = [error.message];
          })
          .finally(() => {
            self.sendingRegistryInfo = false;
          });
    },
    /**
     * 同一条件の登記情報が取得中モーダル：閉じる
     */
    onCancelDuplicate() {
      this.showConfirmDuplicate = false;
      this.removeSpinner();
    },
    /**
     * On cancel get registry
     */
    onCancelGetRegistry() {
      this.showConfirmGetRegistry = false;
      this.removeSpinner();
    },
    /**
     * On confirm get registry
     */
    onConfirmGetRegistry() {
      this.showConfirmGetRegistry = false;
      this.selectedPdfs           = [];
      this.registryInformation();
    },
    /**
     * Get selected pdf
     * @return array
     */
    getSelectedPdf() {
      const pdfTypeSelected                                                     = [];
      pdfTypeSelected[Common.numberTypeParcel]                                  = [];
      pdfTypeSelected[Common.numberTypeParcel][Common.pdfTypeWholeData]         = this.form.checkParcelWholeData;
      pdfTypeSelected[Common.numberTypeParcel][Common.pdfTypeOwnerData]         = this.form.checkParcelOwnerData;
      pdfTypeSelected[Common.numberTypeParcel][Common.pdfTypeMap]               = this.form.checkParcelMap;
      pdfTypeSelected[Common.numberTypeParcel][Common.pdfTypeLandSurveyMap]     = this.form.checkParcelLandSurveyMap;
      pdfTypeSelected[Common.numberTypeParcel][Common.pdfTypeEasementDrawing]   = this.form.checkParcelEasementDrawing;
      pdfTypeSelected[Common.numberTypeParcel][Common.pdfTypeWholeData]         = this.form.checkParcelWholeData;
      pdfTypeSelected[Common.numberTypeParcel][Common.pdfTypeOwnerData]         = this.form.checkParcelOwnerData;
      pdfTypeSelected[Common.numberTypeBuilding]                                = [];
      pdfTypeSelected[Common.numberTypeBuilding][Common.pdfTypeWholeData]       = this.form.checkBuildingWholeData;
      pdfTypeSelected[Common.numberTypeBuilding][Common.pdfTypeOwnerData]       = this.form.checkBuildingOwnerData;
      pdfTypeSelected[Common.numberTypeBuilding][Common.pdfTypeBuildingDrawing] = this.form.checkBuildingDrawings;
      return pdfTypeSelected;
    },
    /**
     * Create params to register registration
     */
    createRegistryInformationParams(defaultStatus = 0) {
      const self            = this;
      let params            = {
        'registrations'           : [],
        't_service_id'            : self.form.t_service_id,
        'password'                : self.form.password,
        'qr_code'                 : self.form.qrCode,
        'joint_security_inventory': self.form.joinSecurity,
        'trust_inventory'         : self.form.trust
      };
      const pdfTypeSelected = self.getSelectedPdf();
      pdfTypeSelected[Common.numberTypeParcel].forEach((numbers, pdfType) => {
        numbers.forEach((number) => {
          self.lotNumber.filter(lotItem => lotItem.parcel_number === number)
              .forEach(lotItem => {
                lotItem.status[pdfType].status = defaultStatus; // Set spinner
                let incidentId                 = null;
                if (pdfType === Common.pdfTypeLandSurveyMap &&
                    self.form.incidentLandSelected[number]) {
                  incidentId = self.form.incidentLandSelected[number];
                } else if (pdfType === Common.pdfTypeEasementDrawing &&
                    self.form.incidentEasementSelected[number]) {
                  incidentId = self.form.incidentEasementSelected[number];
                }
                params['registrations'].push({
                  'pdf_type'          : pdfType,
                  'number_type'       : Common.numberTypeParcel,
                  'v1_code'           : lotItem.v1_code,
                  'number'            : number,
                  'incident_detail_id': incidentId,
                });
              });
        })
      });
      pdfTypeSelected[Common.numberTypeBuilding].forEach((numbers, pdfType) => {
        numbers.forEach((number) => {
          self.houseNumber.filter(houseItem => houseItem.number === number)
              .forEach(houseItem => {
                houseItem.status[pdfType].status = defaultStatus // Set spinner
                let incidentId                   = null;
                if (pdfType === Common.pdfTypeBuildingDrawing &&
                    self.form.incidentDrawingSelected[number]) {
                  incidentId = self.form.incidentDrawingSelected[number];
                }
                params['registrations'].push({
                  'pdf_type'          : pdfType,
                  'number_type'       : Common.numberTypeBuilding,
                  'v1_code'           : houseItem.v1_code,
                  'number'            : number,
                  'incident_detail_id': incidentId,
                });
              });
        })
      });
      // push address, latitude and longitude
      params['registrations'] = params['registrations'].map(registration => {
        if (!self.multiPointMode) {
          return Object.assign(registration, {
            address  : [self.form.address.pref, self.form.address.city, self.form.address.large_section, self.form.address.small_section].join(''),
            latitude : self.form.latitude,
            longitude: self.form.longitude,
          });
        }
        const parcelNumber = self.multiParcelNumber.find(pn => pn.parcel_number === registration.number);
        return Object.assign(registration, {
          address  : [parcelNumber.address.pref, parcelNumber.address.city, parcelNumber.address.large_section, parcelNumber.address.small_section].join(''),
          latitude : parcelNumber.latitude,
          longitude: parcelNumber.longitude,
        });
      });
      return params;
    },
    removeSpinner() {
      const self            = this;
      const pdfTypeSelected = self.getSelectedPdf();
      pdfTypeSelected[Common.numberTypeParcel].forEach((numbers, pdfType) => {
        numbers.forEach((number) => {
          self.lotNumber.filter(lotItem => lotItem.parcel_number === number)
              .forEach(lotItem => {
                lotItem.status[pdfType].status = null; // Set spinner
              });
        })
      });
      pdfTypeSelected[Common.numberTypeBuilding].forEach((numbers, pdfType) => {
        numbers.forEach((number) => {
          self.houseNumber.filter(houseItem => houseItem.number === number)
              .forEach(houseItem => {
                houseItem.status[pdfType].status = null; // Set spinner
              });
        })
      });
    },
    /**
     * Get registry
     */
    registryInformation() {
      const self = this;
      if (self.sendingRegistryInfo) {
        // 多重リクエスト防止
        return;
      }
      self.sendingRegistryInfo = true;
      const params             = self.createRegistryInformationParams();
      this.unFinishCount       = params['registrations'].length;
      this.downloadableCount   = 0;
      apiClient.post(apiList.jon.registration, params)
          .then(response => {
            if (self.hasResponseErrors(response)) {
              self.removeSpinner();
              return;
            }
            if (self.hasNotAvailableRequests(response)) {
              // Tサービス連携API（登記情報提供サービス）が利用不可の場合はエラーを返す
              self.removeSpinner();
              self.unFinishCount = 0;
              self.errorMessages = [Common.messages.registration.not_available];
              return;
            }
            if (self.hasDuplicateRequests(response)) {
              // 以前取得した依頼が残っている場合はエラー内容を表示する
              self.removeSpinner();
              self.unFinishCount = 0;
              self.errorMessages = [Common.messages.registration.duplicated];
              return;
            }

            const tServiceId = self.tServiceId ?? self.form.t_service_id;
            if (self.isTrialUser && self.form.t_service_id) {
              localStorage.setItem(self.getTServiceLocalStorageKey(), Common.encrypt(self.form.t_service_id));
            }
            if (tServiceId) {
              localStorage.setItem(self.getTServicePasswordLocalStorageKey(), Common.encrypt(self.form.password));
            }
            const requestGroup  = response.data['request_group'];
            self.showSnackBar   = true;
            self.successMessage = Common.messages.registration.success;
            self.clearSelectedPdfs();
            self.selectedIncidentId = null;
            self.addTokenToDataPoint(response.data['registrations']);
            self.getRegistrationStatus(requestGroup);
          })
          .catch(error => {
            self.errorMessages = [error.message];
          })
          .finally(() => {
            self.$v.$reset();
            self.sendingRegistryInfo = false;
          });
    },
    /**
     * 重複した依頼を行ったか
     *
     * @param response
     * @return {boolean}
     */
    hasNotAvailableRequests(response) {
      this.validateResponse = [];
      this.errorMessages    = [];
      const result          = response.data;
      if (result.not_available) {
        return true;
      }
      return false;
    },
    /**
     * 図面
     *
     * @param response
     * @return {boolean}
     */
    hasNotAvailableMapAndDrawRequests(response) {
      this.validateResponse = [];
      this.errorMessages    = [];
      const result          = response.data;
      if (result.not_available_map_and_draw) {
        return true;
      }
      return false;
    },
    /**
     * 重複した依頼を行ったか
     *
     * @param response
     * @return {boolean}
     */
    hasDuplicateRequests(response) {
      this.validateResponse = [];
      this.errorMessages    = [];
      const result          = response.data;
      if (result.duplicate && result.duplicate.length > 0) {
        return true;
      }
      return false;
    },
    /**
     * Clear selected pdfs
     */
    clearSelectedPdfs() {
      this.form.checkParcelWholeData.splice(0, this.form.checkParcelWholeData.length);
      this.form.checkParcelOwnerData.splice(0, this.form.checkParcelOwnerData.length);
      this.form.checkParcelMap.splice(0, this.form.checkParcelMap.length);
      this.form.checkParcelLandSurveyMap.splice(0, this.form.checkParcelLandSurveyMap.length);
      this.form.checkParcelEasementDrawing.splice(0, this.form.checkParcelEasementDrawing.length);
      this.form.checkBuildingWholeData.splice(0, this.form.checkBuildingWholeData.length);
      this.form.checkBuildingOwnerData.splice(0, this.form.checkBuildingOwnerData.length);
      this.form.checkBuildingDrawings.splice(0, this.form.checkBuildingDrawings.length);
    },
    /**
     *
     * @param registrations
     */
    addTokenToDataPoint(registrations) {
      registrations.forEach(registration => {
        this.lotNumber.filter(lotItem => (lotItem['parcel_number'] === registration['number'] && registration['number_type'] === Common.numberTypeParcel))
            .forEach(lotItem => {
              lotItem.status[registration['pdf_type']].token  = registration['token'];
              lotItem.status[registration['pdf_type']].status = 0;
            });

        this.houseNumber.filter(houseItem => (houseItem['number'] === registration['number'] && registration['number_type'] === Common.numberTypeBuilding))
            .forEach(houseItem => {
              houseItem.status[registration['pdf_type']].token  = registration['token'];
              houseItem.status[registration['pdf_type']].status = 0;
            });
      });
    },
    /**
     * 登記情報の取得状況を取得する（登記情報取得後に毎秒コールされ進捗を反映するもの）
     *
     * @param requestGroup
     */
    getRegistrationStatus(requestGroup) {
      if (!this.showRegistrationDialog) {
        return;
      }
      const self = this;
      apiClient.post(apiList.jon.registration_status, {'request_group': requestGroup})
          .then(response => {
            if (this.hasResponseErrors(response)) {
              return;
            }
            const registrations = response.data['registrations'];
            registrations.forEach(registration => {
              // 土地の場合
              self.lotNumber.forEach(lotItem => {
                for (let i = 1; i <= 5; i++) {
                  if (lotItem.status[i].token === registration.token) {
                    lotItem.status[i].status = registration.status;
                    if (registration.pre_signed_url) {
                      lotItem.status[i].id             = registration.id;
                      lotItem.status[i].label          = registration.label;
                      lotItem.status[i].pre_signed_url = registration.pre_signed_url;
                      lotItem.status[i].requested_at   = moment().format(Common.momentConst.dateFormat);
                      if (registration.id) {
                        self.selectedPdfs.push(registration.id);
                      }
                    } else if (registration.error_code) {
                      lotItem.status[i].pre_signed_url = null;
                      lotItem.status[i].requested_at   = null;
                      lotItem.status[i].error_code     = registration.error_code;
                      lotItem.status[i].message        = registration.message;
                      lotItem.status[i].summary        = registration.summary;
                    }
                  }
                }
              });
              // 建物の場合
              self.houseNumber.forEach(houseItem => {
                for (let i = 1; i <= 6; i++) {
                  if (!houseItem.status[i]) {
                    continue;
                  }
                  if (houseItem.status[i].token === registration.token) {
                    houseItem.status[i].status = registration.status;
                    if (registration.pre_signed_url) {
                      houseItem.status[i].id             = registration.id;
                      houseItem.status[i].label          = registration.label;
                      houseItem.status[i].pre_signed_url = registration.pre_signed_url;
                      houseItem.status[i].requested_at   = moment().format(Common.momentConst.dateFormat);
                      if (registration.id) {
                        self.selectedPdfs.push(registration.id);
                      }
                    } else if (registration.error_code) {
                      houseItem.status[i].pre_signed_url = null;
                      houseItem.status[i].requested_at   = null;
                      houseItem.status[i].error_code     = registration.error_code;
                      houseItem.status[i].message        = registration.message;
                      houseItem.status[i].summary        = registration.summary;
                    }
                  }
                }
              });
            });

            // 取得処理未完了の数量を算出
            self.unFinishCount = registrations.filter(function (registration) {
              return registration.status === 0;
            }).length;
            if (self.unFinishCount > 0) {
              Common.sleep(Common.checkRegisterInterval).then(() => {
                self.getRegistrationStatus(requestGroup);
              });
            } else {
              self.showCompleteModal = true;
            }

            // ダウンロード可能な数量を算出
            self.downloadableCount = registrations.filter(function (registration) {
              return registration.status === 1 && registration.error_code === undefined;
            }).length;
          })
          .catch(error => {
            this.errorMessages = [error.message];
          })
          .finally(() => {
          });
    },
    /**
     *
     * @param requestedAt
     * @returns {string|null}
     */
    requestedAtFormat(requestedAt) {
      if (moment(requestedAt).isValid() === false) {
        return null;
      }
      return moment(requestedAt).format(Common.momentConst.dateFormatPdf);
    },
    /**
     * エラーポップアップの表示
     * @param summary
     * @param message
     */
    showError(message) {
      this.errorMessages = [message];
      this.showSnackBarError  = true;
    },
    /**
     *
     * @param summary
     * @param message
     */
    showPdfError(summary, message) {
      // Tサービスのメッセージを加工して表示させる場合の対応
      if (message.includes(Common.messages.registration.messages.not_available)) {
        message = Common.messages.registration.not_available;
      }

      this.pdfErrorMessage = `【${summary}】${message}`;
    },
    /**
     *
     */
    checkboxChanged(pdfType) {
      this.validateIncidents();
      switch (pdfType) {
        case Common.pdfTypeWholeData:
          this.selectAll.WholeData = false;
          break;
        case Common.pdfTypeOwnerData:
          this.selectAll.OwnerData = false;
          break;
        case Common.pdfTypeMap:
          this.selectAll.Map = false;
          break;
        case Common.pdfTypeLandSurveyMap:
        case Common.pdfTypeBuildingDrawing:
          this.selectAll.LandSurveyMap = false;
          break;
        case Common.pdfTypeEasementDrawing:
          this.selectAll.EasementDrawing = false;
          break;
      }
    },
    /**
     *
     * @param value
     */
    mdSelected(value) {
      this.validateIncidents();
    },
    /**
     *
     */
    validateIncidents() {
      const self                      = this;
      const filterLand                = self.form.checkParcelLandSurveyMap.filter(number => !self.form.incidentLandSelected[number]);
      const filterEasement            = self.form.checkParcelEasementDrawing.filter(number => !self.form.incidentEasementSelected[number]);
      const filterDrawing             = self.form.checkBuildingDrawings.filter(number => !self.form.incidentDrawingSelected[number]);
      this.form.incidentSelectedError = filterLand.length > 0 || filterEasement.length > 0 || filterDrawing.length > 0;
    },
    /**
     * 家屋番号の高さを動的に変更し返す
     *
     * @returns {{maxHeight: string}}
     */
    houseNumberHeight() {
      return {
        maxHeight: (this.windowInnerHeight - 500) + 'px',
      }
    },
    /**
     * 家屋番号一覧の幅を地番一覧と同期させる
     */
    houseNumberSyncWidth() {
      const parcelNumberTable = document.querySelector('.parcel-number table');
      const houseNumberTable  = document.querySelector('.house-number table');
      if (typeof parcelNumberTable === 'undefined' || typeof houseNumberTable === 'undefined' ||
          parcelNumberTable === null || houseNumberTable === null ||
          typeof parcelNumberTable.rows === 'undefined' || typeof houseNumberTable.rows === 'undefined' ||
          typeof parcelNumberTable.rows[0] === 'undefined' || typeof houseNumberTable.rows[0] === 'undefined' ||
          typeof parcelNumberTable.rows[0].cells === 'undefined' || typeof houseNumberTable.rows[0].cells === 'undefined') {
        return;
      }

      parcelNumberTable.style.width = (window.innerWidth - 90) + 'px';
      houseNumberTable.style.width  = (window.innerWidth - 90) + 'px';
      const parcelNumberCells       = parcelNumberTable.rows[1].cells;
      const houseNumberCells        = houseNumberTable.rows[0].cells;
      for (let i = 0; i < parcelNumberCells.length; i++) {
        const cellWidth                  = (parcelNumberCells[i].style.width === '')
            ? (parcelNumberCells[i].clientWidth + 2) + 'px'
            : parcelNumberCells[i].style.width;
        parcelNumberCells[i].style.width = cellWidth;
        houseNumberCells[i].style.width  = cellWidth;
      }
    },
    /**
     * Trigger an event when click to hidden password
     */
    triggerPasswordFocus() {
      this.isHiddenPassword = false;
      this.$nextTick(() => {
        this.$refs.password.$el.focus();
      })
    },
    loadTServiceIdFromStorage() {
      if (this.isTrialUser) {
        this.form.t_service_id = Common.decrypt(localStorage.getItem(this.getTServiceLocalStorageKey()));
      }
    },
    loadPasswordFromStorage() {
      // Display password
      this.form.hiddenPassword = null;
      this.form.password       = Common.decrypt(localStorage.getItem(this.getTServicePasswordLocalStorageKey()));
      if (this.form.password !== null) {
        this.form.hiddenPassword = '•'.repeat(this.form.password.length);
        this.hasSavePassword     = true;
      }
    },
    /**
     * 選択した登記情報法
     *
     * @returns {{pdfTypeMap: number, pdfTypeBuildingDrawing: number, pdfTypeOwnerData: number, pdfTypeEasementDrawing: number, pdfTypeWholeData: number, pdfTypeLandSurveyMap: number}}
     */
    selectedRegistries() {
      if (this.form.checkParcelWholeData.length === 0 &&
          this.form.checkBuildingWholeData.length === 0 &&
          this.form.checkParcelOwnerData.length === 0 &&
          this.form.checkBuildingOwnerData.length === 0 &&
          this.form.checkParcelMap.length === 0 &&
          this.form.checkParcelLandSurveyMap.length === 0 &&
          this.form.checkParcelEasementDrawing.length === 0 &&
          this.form.checkBuildingDrawings.length === 0) {
        return null;
      }

      return {
        'pdfTypeWholeData'      : this.form.checkParcelWholeData.length + this.form.checkBuildingWholeData.length, // 全部事項
        'pdfTypeOwnerData'      : this.form.checkParcelOwnerData.length + this.form.checkBuildingOwnerData.length, // 所有者事項
        'pdfTypeMap'            : this.form.checkParcelMap.length, // 地図(公図)
        'pdfTypeLandSurveyMap'  : this.form.checkParcelLandSurveyMap.length, // 地積測量図
        'pdfTypeEasementDrawing': this.form.checkParcelEasementDrawing.length, // 地役権図面
        'pdfTypeBuildingDrawing': this.form.checkBuildingDrawings.length, // 建物図面
      };
    },
    onBatchDownload() {
      if (this.selectedPdfs.length > Common.downloadPdfLimitModal) {
        this.errorMessages = [Common.messages.pdf.limitModalError];
        return;
      }
      this.downloadPdfs().then();
    },
    currentMonth() {
      return moment().format(Common.momentConst.dateFormatPdf);
    },
    checkHasReacquisition() {
      const self            = this;
      this.hasReacquisition = false;
      const pdfTypeSelected = this.getSelectedPdf();
      pdfTypeSelected[Common.numberTypeParcel].forEach((numbers, pdfType) => {
        numbers.forEach((number) => {
          if (self.lotNumber.filter(lotItem => lotItem.parcel_number === number && lotItem.status[pdfType].pre_signed_url).length > 0) {
            self.hasReacquisition = true;
          }
        })
      })
      if (self.hasReacquisition) {
        return;
      }
      pdfTypeSelected[Common.numberTypeBuilding].forEach((numbers, pdfType) => {
        numbers.forEach((number) => {
          if (self.houseNumber.filter(houseItem => houseItem.number === number && houseItem.status[pdfType].pre_signed_url).length > 0) {
            self.hasReacquisition = true;
          }
        })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/components.scss";

.md-dialog-registration {
  display: flex;
  width: 100%;

  ::v-deep(.md-dialog-container) {
    min-width: 100%;
    min-height: 100%;
  }

  &.md-confirming {
    background-color: #cccccc;

    .md-dialog-title {
      background-color: #cccccc;
      opacity: 0.7;
      margin-bottom: 0;
      padding: 24px 24px 20px;
    }
  }
}

.md-loading {
  text-align: center;

  &-building-number {
    background-color: #D6D6D6;
    color: #444;
  }
}

/** 取得モーダル.地番／家屋番号一覧 **/
.parcel-number,
.house-number {
  .md-table-row {
    /** テーブル表題部 **/
    .md-table-head {
      text-align: center;
      border: solid 1px rgba(0, 0, 0, 0.2);

      ::v-deep(.md-table-head-container) {
        height: 26px;
        padding: 0;

        .md-table-head-label {
          padding-right: 0;
          padding-left: 0;
        }
      }

      .md-icon-button {
        width: 25px;
        min-width: 25px;
        height: 25px;
      }
    }

    /** テーブル一覧部 **/
    .md-table-cell {
      text-align: center;
      border: solid 1px rgba(0, 0, 0, 0.2);
      height: 36px;
      padding: 0 !important;

      .md-field, .md-checkbox {
        margin: 0 !important;
      }

      .md-field {
        min-height: 36px;
        padding-top: 0;

        &:before,
        &:after {
          content: none;
        }
      }

      ::v-deep(.md-table-cell-container) {
        padding: 3px 3px 0 3px;
        height: 25px;
        font-size: 14px;

        .md-select {
          margin-top: -0.5em;
        }

        label {
          font-size: 12px;
        }
      }

      ::v-deep(.md-field.md-theme-default.md-has-value.md-input) {
        font-size: 12px;
      }

      ::v-deep(.md-progress-spinner) {
        margin: 3px;
      }
    }

    /** 土地、建物 **/
    .md-table-head:nth-child(1),
    .md-table-cell:nth-child(1) {
      min-width: 18px;
      max-width: 18px;
      text-align: center;
      overflow: hidden;

      ::v-deep(.md-table-cell-container) {
        padding-top: 0;
      }
    }

    .md-table-head.md-hidden,
    .md-table-cell.md-hidden {
      display: table-cell;
      min-width: 0 !important;
      max-width: 0 !important;
      border: 0;

      & * {
        display: inline-block;
        min-width: 0 !important;
        max-width: 0 !important;
      }
    }

    /** 土地、建物 **/
    .md-table-head:nth-child(2),
    .md-table-cell:nth-child(2) {
      min-width: 200px;
      background-color: #f8f8f8;
    }

    .md-table-cell:nth-child(2) {
      text-align: left;
      overflow: hidden;
    }

    /** 取得状況（空白、日付、ローディングアイコンが入る） **/
    .md-table-head:nth-child(3),
    .md-table-head:nth-child(5),
    .md-table-head:nth-child(7),
    .md-table-head:nth-child(9),
    .md-table-head:nth-child(11),
    .md-table-cell:nth-child(3),
    .md-table-cell:nth-child(5),
    .md-table-cell:nth-child(7),
    .md-table-cell:nth-child(9),
    .md-table-cell:nth-child(12) {
      min-width: 52px;
      max-width: 52px;
    }

    /** 事件情報リストボックス  **/
    .md-table-cell:nth-child(10),
    .md-table-cell:nth-child(13) {
      min-width: 94px;
      max-width: 94px;
      font-size: 14px;
      border-left: dotted 2px rgba(0, 0, 0, 0.1);
    }

    /** チェックボックス  **/
    .md-table-head:nth-child(4),
    .md-table-head:nth-child(6),
    .md-table-head:nth-child(8),
    .md-table-head:nth-child(10),
    .md-table-head:nth-child(12),
    .md-table-cell:nth-child(4),
    .md-table-cell:nth-child(6),
    .md-table-cell:nth-child(8),
    .md-table-cell:nth-child(11),
    .md-table-cell:nth-child(14) {
      min-width: 40px;
      max-width: 40px;
      border-left: dotted 2px rgba(0, 0, 0, 0.1);
    }

    .md-table-head:nth-child(3),
    .md-table-head:nth-child(5),
    .md-table-head:nth-child(7),
    .md-table-head:nth-child(9),
    .md-table-head:nth-child(11),
    .md-table-cell:nth-child(3),
    .md-table-cell:nth-child(5),
    .md-table-cell:nth-child(7),
    .md-table-cell:nth-child(9),
    .md-table-cell:nth-child(12) {
      border-left: solid 2px rgba(0, 0, 0, 0.2);
    }
  }

  .md-table-row:nth-child(2),
  .md-table-row:nth-child(4) {
    .md-table-head {
      background-color: #f4fdff;
    }
  }
}

.parcel-number {
  overflow-y: scroll;

  .md-table-row:last-child {
    .md-table-cell {
      border-bottom: solid 2px rgba(0, 0, 0, 0.2);
    }
  }
}

.house-number {
  max-height: 196px;
  overflow: auto;

  .md-table-row {
    /** 未使用  **/
    .md-table-cell:nth-child(7),
    .md-table-cell:nth-child(8),
    .md-table-cell:nth-child(12),
    .md-table-cell:nth-child(13),
    .md-table-cell:nth-child(14) {
      background-color: #f8f8f8;
    }
  }

  .md-table-row:nth-child(2) {
    .md-table-cell {
      border-top: 0px;
    }
  }
}

.md-dialog-close-button {
  position: absolute;
  top: 0;
  right: 0;
  margin: 24px;
  cursor: pointer;
}

/** オプション **/
.md-layout-options {
  background-color: #f8f8f8;
  border-radius: 8px;
  padding-top: 10px;

  label {
    font-size: 13px;
  }

  ::v-deep(.md-radio) {
    margin: 5px 16px 5px 0;
  }

  ::v-deep(.md-radio-label) {
    padding-left: 8px;
    font-size: 13px;
  }
}

.mb-0 {
  margin-bottom: 0;
}

.mb-20 {
  margin-bottom: 20px;
}

.ie-browser {
  .md-table {
    flex-direction: inherit;
  }
}

.pdf-selected-error {
  margin-bottom: 20px;

  &.md-invalid {
    display: grid;

    .md-error {
      font-size: 14px;
    }
  }
}

.md-field-remove-input {
  min-height: 0;
  padding-top: 0;
  /*margin: 0;*/

  &:after {
    display: none;
  }
}

.text-error {
  color: #ff5252;
}

.text-link {
  color: #448aff;
}

/** タブレット対応（できる限りPC版と同じ見た目で縮小する **/
@media (max-width: 1024px) {
  /** 取得モーダル.地番／家屋番号一覧 **/
  .parcel-number,
  .house-number {
    .md-table-row {
      .md-table-head {
        font-size: 11px;
      }

      /** テーブル一覧部 **/
      .md-table-cell {
        height: 36px;
        font-size: 13px;

        ::v-deep(.md-table-cell-container) {
          font-size: 13px;
        }

        ::v-deep(.md-field.md-theme-default.md-has-value.md-input) {
          font-size: 13px;
        }
      }

      /** 土地、建物 **/
      .md-table-head:nth-child(2),
      .md-table-cell:nth-child(2) {
        min-width: 120px;
      }
    }
  }

  /** オプション **/
  .md-layout-options {
    label {
      font-size: 10px;
    }

    ::v-deep(.md-radio-label) {
      padding-left: 4px;
      font-size: 10px;
    }
  }
}
</style>

<style lang="scss">
.md-select-menu {
  z-index: 20 !important;
}

.md-icon-sm {
  height: 32px !important;
}

pre {
  font-family: 'Liberation Serif', 'Noto Sans CJK JP', /* Linux/Android/ChromeOS */
  'Yu Gothic', 'MS Gothic', /* Windows */
  'Hiragino Sans', 'Hiragino Kaku Gothic ProN', 'Osaka-Mono', /* Mac/iOS */
  'Noto Sans JP', Monospace;
  overflow-y: auto;
  max-height: 200px;
}
</style>
